angular.module('app', ['ui.router', 'LocalStorageModule'])
    .config(function (config, $httpProvider, $locationProvider, $urlRouterProvider, localStorageServiceProvider) {
        $httpProvider.interceptors.push('httpInterceptor');

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: true
        });

        localStorageServiceProvider
            .setPrefix(config.projectName)
            .setStorageType(config.storageType)
            .setStorageCookie(0, '/', false)
            .setNotify(true, true);

        $urlRouterProvider.when('', '/vender');
        $urlRouterProvider.when('/', '/vender');
        $urlRouterProvider.otherwise('/404');
    })
    .run(function ($rootScope, $state, $stateParams, $window, localStorageService, userService, $q, venderService, $sce, config, relationService, layerService) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (_hmt) {
                _hmt.push(['_trackPageview', window.location.pathname]);
            }
        });

        $rootScope.nativeGo = function (name) {
            window.location.href = $state.href(name);
        };

        $rootScope.nativeOpen = function (name, obj) {
            window.open($state.href(name, obj));
        };

        $rootScope.getActivityTime = function (start, end) {
            var startStr = start.substring(0, 10).split('-');
            var startTemp = startStr[0] + '年' + startStr[1] + '月' + startStr[2] + '日';
            var endStr = end.substring(0, 10).split('-');
            var endTemp = endStr[0] + '年' + endStr[1] + '月' + endStr[2] + '日';
            if (startTemp == endTemp) {
                return startTemp + ' ' + start.substring(11, 16) + ' - ' + end.substring(11, 16);
            } else {
                return startTemp + ' ' + start.substring(11, 16) + ' - ' + endTemp + ' ' + end.substring(11, 16);
            }
        };

        $rootScope.getActivityTypeName = function (value) {
            var types = config.activityTypeList;
            for (var i = 0; i < types.length; i++) {
                if (types[i].value == value) {
                    return types[i].name;
                }
            }
        };

        $rootScope.safeHtml = function (value) {
            return $sce.trustAsHtml(value);
        };


        var getDeadline = function (startTime) {
            var yesterday_milliseconds = startTime.getTime() - 1000 * 60 * 60 * 24;

            var yesterday = new Date();
            yesterday.setTime(yesterday_milliseconds);

            var strYear = yesterday.getFullYear();

            var strDay = yesterday.getDate();
            var strMonth = yesterday.getMonth() + 1;

            if (strMonth < 10) {
                strMonth = "0" + strMonth;
            }
            return new Date(strYear + "/" + strMonth + "/" + strDay + ' 17:00:00');
        };
        $rootScope.compareWithNow = function (startTime, endTime) {
            if (!startTime || !endTime) {
                return false;
            }
            var nowDate = new Date();
            startTime = new Date(startTime.replace(/\-/g, "\/"));
            endTime = new Date(endTime.replace(/\-/g, "\/"));
            return startTime < nowDate && endTime > nowDate;
        };

        var sendReserve = function (documentId, orderNum, phone) {
            relationService.add({
                documentId: documentId,
                orderNum: orderNum,
                orderMobileId: phone
            }).then(function (data) {
                if (data.status == 0) {
                    layer.alert('恭喜您，您已成功预约' + orderNum + '个活动名额！请按照要求携带相关证件，到场参加！', function (index) {
                        layer.close(index);
                        $rootScope.$state.reload();
                    });
                } else if (data.statusDesc == 'docid不存在') {
                    layer.alert('活动已停止预约，预约失败。');
                } else {
                    layer.alert(data.statusDesc);
                }
            }, function () {
                layer.msg('您已预约过该活动，不能重复预约');
            })
        };
        $rootScope.reserve = function (item) {
            if (item.documentRemainNum == 0) {
                return;
            }
            $rootScope.userInfo(true).then(function (data) {

                var authorities = data.supplement.authorities;
                var community = false;
                for (var i = 0; i < authorities.length; i++) {
                    if (authorities[i].authority == 'ROLE_COMMUNITY') {
                        community = true;
                        break;
                    }
                }

                if (i == authorities.length && data.result.userType == 'community') {
                    layer.confirm('您还未完成团体用户认证，暂时不可进行预约。', {title: '提示', btn: ['立即认证', '再看看']}, function (index) {
                        $rootScope.$state.go('user.auth');
                        layer.close(index);
                    });
                    return;
                }

                if (data.result.phone) {
                    var orderNum = item.documentUserLimit;
                    if (community) {
                        orderNum = item.documentCommunityLimit;
                    }
                    if (orderNum > 1) {
                        layer.prompt({
                            title: '请输入您的预约人数，如有疑问，请咨询活动发布方。',
                            value: 1,
                        }, function (pass, index) {
                            if (isNaN(pass * 1) || pass * 1 > orderNum) {
                                layer.msg('请输入不大于 ' + orderNum + ' 的正整数', {time: 2000});
                                return;
                            }
                            layer.close(index);
                            sendReserve(item.documentId, pass, data.result.phone)
                        });
                    } else {
                        sendReserve(item.documentId, 1, data.result.phone)
                    }
                } else {
                    layerService.confirm('提醒', '您还未完善个人信息，完善后方可进行预约', ['立即完善']).then(function () {
                        $rootScope.$state.go('user.update')
                    })
                }

            });
        };

        var localData = function (data) {
            localStorageService.set('trueName', data.result.trueName);
            localStorageService.set('userName', data.result.userName);
            localStorageService.set('userId', data.result.userId);
            localStorageService.set('userType', data.result.userType);
            $rootScope.$broadcast('getInfoSuccess');
        };

        var userInfo = null;
        $rootScope.userInfo = function (clear) {
            var defer = $q.defer();
            if (userInfo && !clear) {
                localData(userInfo);
                defer.resolve(userInfo);
            } else {
                userService.getInfo().then(function (data) {
                    userInfo = data;
                    localData(data);
                    defer.resolve(userInfo);
                })
            }
            return defer.promise;
        };


        //获取推荐机构
        var currentVenderType = 1;
        var recommendData = null;
        $rootScope.recommendData = function (venderType) {
            var defer = $q.defer();
            if (recommendData && venderType == currentVenderType) {
                defer.resolve(recommendData);
            } else {
                currentVenderType = venderType;
                venderService.getList(0, 1, {
                    venderType: venderType,
                    recommend: true
                }).then(function (data) {
                    recommendData = data;
                    defer.resolve(recommendData);
                })
            }
            return defer.promise;
        };


        $rootScope.getStatusTypeName = function (value) {
            var name = '';
            if (value == 'active') {
                name = '审核通过'
            } else if (value == 'inactive') {
                name = '新增待审核'
            } else if (value == 'delete') {
                name = '删除'
            } else if (value == 'reback') {
                name = '审核驳回'
            } else if (value == 'modified') {
                name = '修改待审核'
            }
            return name;
        };


        if (localStorageService.get('token')) {
            $rootScope.userInfo();
        }

        $rootScope.back = function () {
            $window.history.back();
        };
    });

/**
 * Created by lxp on 2016/7/18.
 */
angular.module('app').constant('config', {
    //项目名称
    projectName: 'kph-web',

    //数据存储方式
    storageType: 'cookie',

    //api接口服务地址
    // apiHost: 'http://172.16.201.151:23456',
    apiHost: 'http://kph.tjkp.org.cn',

    //分页配置
    limit: 15,

    //TRS Host地址
    trsHost: 'http://kph.tjkp.org.cn/',

    //七牛服务配置
    qiniuDomain: 'http://7xr9ex.com1.z0.glb.clouddn.com/',
    qiniuToken: '4tJta98vtUUmgKY2NfjKFr3zSKqLnZOkNjUE51xC:g8zjGjhRUuzZbPKl7fQCZHpM-yU=:eyJyZXR1cm5Cb2R5Ijoie1wia2V5XCI6JChrZXkpLFwiaGFzaFwiOiQoZXRhZyksXCJ3XCI6JChpbWFnZUluZm8ud2lkdGgpLFwiaFwiOiQoaW1hZ2VJbmZvLmhlaWdodCksXCJzaXplXCI6JChmc2l6ZSl9Iiwic2NvcGUiOiJpbWFnZXMiLCJkZWFkbGluZSI6MzUwMjg1NDIwMn0=',


    //图片验证码
    imgCodes: [
        {
            img: 'getCode0.png',
            code: 'kq2wn'
        },
        {
            img: 'getCode1.png',
            code: 'd8eyr'
        },
        {
            img: 'getCode2.png',
            code: 'eq8yx'
        },
        {
            img: 'getCode3.png',
            code: 'ky3xr'
        },
        {
            img: 'getCode4.png',
            code: 'k3823'
        },
        {
            img: 'getCode5.png',
            code: '8y3xk'
        },
        {
            img: 'getCode6.png',
            code: 'p8kyw'
        },
        {
            img: 'getCode7.png',
            code: 'nwkdy'
        },
        {
            img: 'getCode8.png',
            code: 'pkfa2'
        },
        {
            img: 'getCode9.png',
            code: 'x22aw'
        },
        {
            img: 'getCode10.png',
            code: 'x3rdr'
        }
    ],


    //机构类型
    venderTypeList: [{
        name: '全部类型',
        value: '0'
    }, {
        name: '科普场馆',
        value: '1'
    }, {
        name: '主题公园',
        value: '2'
    }, {
        name: '青少年科普活动站',
        value: '3'
    }, {
        name: '机构开放',
        value: '4'
    }, {
        name: '其他店铺',
        value: '5'
    }],

    //活动分类
    activityCategoryList: [{
        name: '全部分类',
        value: '0'
    }, {
        name: '公园展馆',
        value: '2'
    }, {
        name: '观光农业',
        value: '3'
    }, {
        name: '创新探索',
        value: '4'
    }, {
        name: '健康养生',
        value: '5'
    }, {
        name: '益智成长',
        value: '1'
    }, {
        name: '优惠专区',
        value: '6'
    }],

    //活动标签
    activityTagList: [{
        name: '全部地域',
        value: '0'
    }, {
        name: '本市科普活动',
        value: '1'
    }, {
        name: '京津冀科普旅游',
        value: '2'
    }, {
        name: '外省市科普活动',
        value: '3'
    }],

    //活动类型
    activityTypeList: [{
        name: '全部类型',
        value: '0'
    }, {
        name: '讲座',
        value: '1'
    }, {
        name: '参观',
        value: '2'
    }, {
        name: '青少年活动',
        value: '3'
    }]
});
/**
 * Created by lxp on 2016/7/21.
 */
angular.module('app').provider("routerManager", function ($stateProvider) {
    var routes = {};

    this.add = function (name, option) {
        $stateProvider.state(name, option);
        option.sort = option.sort || 0;
        var routesName = name.split('.');
        routes[name] = $.extend(routes[name], option);

        var childName = routesName.pop();
        if (routesName.length > 0) {
            var parent = routesName.join('.');
            routes[parent] = routes[parent] || {};
            routes[parent].children = routes[parent].children || {};
            routes[parent].children[childName] = routes[name];
            routes[name].parent = routes[parent];
        }

    };
    this.$get = function () {
        var server = {};
        server.getRoutes = function () {
            var routers = $.extend({}, routes);
            for (var key in routers) {
                if (key.split('.').length > 1) {
                    delete routers[key];
                }
            }
            return routers;
        };

        server.getRouteByName = function (name) {
            return routes[name] || {};
        };

        server.setAttribute = function (name, key, value) {
            routes[name][key] = value;
        };

        return server;
    }
});

/**
 * Created by lxp on 2016/7/22.
 */
'use strict';
angular.module('app').provider('util',
    function () {
        var serialize = function (obj) {
            var arr = [];
            for (var key in obj) {
                if (obj[key] === '' || obj[key] === undefined)continue;
                arr.push(encodeURI(key) + '=' + encodeURI(obj[key]));
            }
            return arr.join('&');
        };
        var deserialize = function (str) {
            if (!str || typeof str != 'string') return {};
            var obj = {};
            var arr = str.split('&');
            for (var i = 0, j = arr.length; i < j; i++) {
                var item = arr[i].split('=');
                obj[decodeURI(item[0])] = decodeURI(item[1]);
            }
            return obj;
        };


        var formPost = function (url, args) {
            var form = $("<form method='post' target='_blank'></form>");
            form.attr({"action": url});
            for (var i = 0; i < args.length; i++) {
                var input = $("<input type='hidden'>");
                input.attr({"name": args[i].name});
                input.val(args[i].value);
                form.append(input);
            }
            $('body').append(form);
            form.submit();
            form.remove();
        };

        this.serialize = serialize;
        this.deserialize = deserialize;
        this.formPost = formPost;

        this.$get = function () {
            var server = {};
            server.getObjectValueToArray = function (obj) {
                var arr = [];
                for (var key in obj) {
                    arr.push(obj[key]);
                }
                return arr;
            };
            server.deserialize = deserialize;
            server.serialize = serialize;
            server.formPost = formPost;

            return server;
        };
    }
);

angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('activity.detail', {
            url: '/detail/{id:.*}',
            templateUrl: 'app/module/activity/detail/detail.html',
            controller: 'activityDetailController',
            resolve: {
                initData: ['$stateParams', 'config', 'activityService', '$q', 'oprlogService', 'localStorageService',
                    function ($stateParams, config, activityService, $q, oprlogService, localStorageService) {
                        var data = {
                            pvTag1: 'document',
                            pvValue: $stateParams.id
                        };
                        if (localStorageService.get('userId')) {
                            data.pvTag3 = localStorageService.get('userId');
                        }
                        return $q.all([
                            activityService.getById($stateParams.id),
                            oprlogService.add(data)
                        ])
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider, utilProvider) {
    $stateProvider
        .state('activity.list', {
            url: '/list/{pageNum:[1-9][0-9]*}?search',
            templateUrl: 'app/module/activity/list/list.html',
            controller: 'activityListController',
            resolve: {
                initData: ['$stateParams', 'config', 'activityService',
                    function ($stateParams, config, activityService) {
                        $stateParams.pageNum = $stateParams.pageNum || 1;
                        var limit = 6;
                        var search = utilProvider.deserialize($stateParams.search);
                        search.documentStatus = 'active';
                        search.venderStatus = 'active';

                        if (search.veT * 1) {
                            //店铺类型
                            search.venderType = search.veT;
                        }

                        if (search.acT * 1) {
                            //活动类型
                            search.documentType = search.acT;
                        }
                        if (search.acC * 1) {
                            //acC活动分类
                            search.documentTag2 = search.acC;
                        }
                        if (search.acTa * 1) {
                            //活动地域
                            search.documentTag1 = search.acTa;
                        }
                        if (search.acN) {
                            search.documentTitle = search.acN;
                        }

                        if (search.month) {
                            var date = new Date();
                            var year = date.getFullYear();
                            var month = date.getMonth() + 1;

                            var fn = function (month) {
                                if (month < 10) {
                                    search.startTime = year + '-0' + month + '-01 00:00:00';
                                } else if (month == 13) {
                                    search.startTime = (year + 1) + '-01' + '-01 00:00:00';
                                } else {
                                    search.startTime = year + '-' + month + '-01 00:00:00';
                                }

                                if (month + 1 < 10) {
                                    search.endTime = year + '-0' + (month + 1) + '-01 00:00:00';
                                } else if (month + 1 == 13) {
                                    search.endTime = (year + 1) + '-01' + '-01 00:00:00';
                                } else if (month + 1 == 14) {
                                    search.endTime = (year + 1) + '-02' + '-01 00:00:00';
                                } else {
                                    search.endTime = year + '-' + (month + 1) + '-01 00:00:00';
                                }
                            };

                            if (search.month == 'current') {
                                fn(month);
                                search.valid = true;
                            } else if (search.month == 'next') {
                                fn(month + 1);
                                search.valid = true;
                            } else if (search.month == 'history') {
                                search.valid = false;
                            } else if (search.month == 'all'){
                                delete search.valid;
                            }
                        } else {
                            delete search.valid;
                            //search.valid = true;
                        }

                        if (search.time) {
                            search.startTime = search.time + ' 00:00:00';
                            search.endTime = search.time + ' 23:59:59';
                        }

                        if (search.acV * 1 == 1) {
                            search.valid = true;
                        } else if (search.acV * 1 == 2) {
                            search.valid = false;
                        }

                        
                        delete search.veT;
                        delete search.acC;
                        delete search.acT;
                        delete search.acV;
                        delete search.acTa;
                        delete search.acN;
                        delete search.month;
                        delete search.time;

                        var promise = activityService.getList(($stateParams.pageNum - 1) * limit, limit, search);
                        promise.then(function () {
                        }, function (err) {
                            var message = err.message.split(',key: ');
                            layer.msg('您的操作中含有敏感词汇【' + message[1] + '】,请重试！', {icon: 5});
                        });
    
                        return promise;
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('user.auth', {
            url: '/auth',
            templateUrl: 'app/module/user/auth/auth.html',
            controller: 'userAuthController',
            resolve: {
                initData: ['$stateParams', 'config', '$rootScope', 'communityService',
                    function ($stateParams, config, $rootScope, communityService) {
                        return communityService.getInfo();
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('user.list', {
            url: '/list/{pageNum:[1-9][0-9]*}?search',
            templateUrl: 'app/module/user/list/list.html',
            controller: 'userListController',
            resolve: {
                initData: ['$stateParams', 'config', 'relationService', 'localStorageService',
                    function ($stateParams, config, relationService, localStorageService) {
                        $stateParams.pageNum = $stateParams.pageNum || 1;
                        return relationService.getList(($stateParams.pageNum - 1) * config.limit, config.limit, {
                            userId: localStorageService.get('userId')
                        });
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('user.info', {
            url: '/info',
            templateUrl: 'app/module/user/info/info.html',
            controller: 'userInfoController',
            resolve: {
                initData: ['$stateParams', 'config', '$rootScope',
                    function ($stateParams, config, $rootScope) {
                        return $rootScope.userInfo(true);
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('user.update', {
            url: '/update',
            templateUrl: 'app/module/user/update/update.html',
            controller: 'userUpdateController',
            resolve: {
                initData: ['$stateParams', 'config', '$rootScope',
                    function ($stateParams, config, $rootScope) {
                        return $rootScope.userInfo();
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('user.pwd', {
            url: '/pwd',
            templateUrl: 'app/module/user/pwd/pwd.html',
            controller: 'userPwdController'
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('vender.detail', {
            url: '/detail/{id:.*}',
            templateUrl: 'app/module/vender/detail/detail.html',
            controller: 'venderDetailController',
            resolve: {
                initData: ['$stateParams', 'config', 'venderService', '$q', 'oprlogService', 'localStorageService',
                    function ($stateParams, config, venderService, $q, oprlogService, localStorageService) {
                        var data = {
                            pvTag1: 'vender',
                            pvValue: $stateParams.id
                        };
                        if (localStorageService.get('userId')) {
                            data.pvTag3 = localStorageService.get('userId');
                        }
                        return $q.all([
                            venderService.getById($stateParams.id),
                            oprlogService.add(data)
                        ])
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('vender.list', {
            url: '/list/{venderType:[1-9]*}/{pageNum:[1-9][0-9]*}',
            templateUrl: 'app/module/vender/list/list.html',
            controller: 'venderListController',
            resolve: {
                initData: ['$stateParams', 'config', 'venderService', '$q', '$rootScope',
                    function ($stateParams, config, venderService, $q, $rootScope) {
                        $stateParams.pageNum = $stateParams.pageNum || 1;
                        $stateParams.venderType = $stateParams.venderType || 1;
                        var limit = 6;

                        return $q.all([
                            $rootScope.recommendData($stateParams.venderType),
                            venderService.getList(($stateParams.pageNum - 1) * limit, limit, {
                                venderType: $stateParams.venderType,
                                recommend: false
                            })
                        ])
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider, utilProvider) {
    $stateProvider
        .state('vender.search', {
            url: '/search/{pageNum:[1-9][0-9]*}?search',
            templateUrl: 'app/module/vender/search/search.html',
            controller: 'venderSearchController',
            resolve: {
                initData: ['$stateParams', 'config', 'venderService', '$q', '$rootScope',
                    function ($stateParams, config, venderService, $rootScope) {
                        var limit = 6;
                        $stateParams.pageNum = $stateParams.pageNum || 1;
                        var search = utilProvider.deserialize($stateParams.search);
                        if (search.acN) {
                            search.venderName = search.acN;
                        }
                        delete search.acN;

                        var promise = venderService.getList(($stateParams.pageNum - 1) * limit, limit, search);
                        promise.then(function () {
                        }, function (err) {
                            var message = err.message.split(',key: ');
                            layer.msg('您的操作中含有敏感词汇【' + message[1] + '】,请重试！', {icon: 5});
                        });
                        return promise
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/activity', '/activity/list/1');

    $stateProvider
        .state('activity', {
            url: '/activity',
            templateUrl: 'app/module/activity/activity.html',
            controller: 'activityController',
            resolve: {
                initData: ['$stateParams', 'config', 'activityService',
                    function ($stateParams, config, activityService) {
                        $stateParams.pageNum = $stateParams.pageNum || 1;
                        var search = {
                            valid: true
                        };
                        return activityService.getList(0, 100000, search);
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {


    $stateProvider
        .state('kptj', {
            url: '/kptj',
            templateUrl: 'app/module/kptj/kptj.html',
            controller: 'kptjController',
            resolve: {
                initData: ['$stateParams', 'config', 'userService',
                    function ($stateParams, config, activityService) {
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('forget', {
            url: '/forget',
            templateUrl: 'app/module/forget/forget.html',
            controller: 'forgetController'
        });
});


angular.module('app').config(function ($stateProvider) {


    $stateProvider
        .state('login', {
            url: '/login',
            templateUrl: 'app/module/login/login.html',
            controller: 'loginController'
        });
});


angular.module('app').config(function ($stateProvider) {
  $stateProvider
    .state('noMatch', {
      url: '/404',
      templateUrl: 'app/module/noMatch/noMatch.html'
    });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('print', {
            url: '/print/{id:.*}',
            templateUrl: 'app/module/print/print.html',
            controller: 'printController',
            resolve: {
                initData: ['$stateParams', 'config', 'relationService',
                    function ($stateParams, config, relationService) {
                        return relationService.getById($stateParams.id);
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {


    $stateProvider
        .state('register', {
            url: '/register',
            templateUrl: 'app/module/register/register.html',
            controller: 'registerController',
            resolve: {
                initData: ['$stateParams', 'config', 'userService',
                    function ($stateParams, config, activityService) {
                        // $stateParams.pageNum = $stateParams.pageNum || 1;
                        // var search = {
                        //     valid: true
                        // };
                        //return userService.getSecurityCode();
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider) {
    $stateProvider
        .state('setPwd', {
            url: '/setPwd/{code:.*}',
            templateUrl: 'app/module/setPwd/setPwd.html',
            controller: 'setPwdController'
        });
});


angular.module('app').config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/user', '/user/info');
    $stateProvider
        .state('user', {
            url: '/user',
            templateUrl: 'app/module/user/user.html',
            controller: 'userController',
            resolve: {
                initData: ['$stateParams', 'config', 'communityService',
                    function ($stateParams, config, communityService) {
                        return communityService.getInfo();
                    }
                ]
            }
        });
});


angular.module('app').config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('/vender', '/vender/list/1/1');

    $stateProvider
        .state('vender', {
            url: '/vender',
            templateUrl: 'app/module/vender/vender.html',
            controller: 'venderController'
        });
});


angular.module('app').config(function ($stateProvider, $urlRouterProvider) {
    //$urlRouterProvider.when('/yy', '/yy/list/1/1');

    $stateProvider
        .state('yy', {
            url: '/yy',
            templateUrl: 'app/module/yy/yy.html',
            controller: 'yyController'
        });
});


'use strict';

angular.module('app').service('activityService',
    function (basicService) {

        this.getList = function (offset, limit, data) {
            var api = '/public/document/list/' + offset + '/' + limit;
            data.venderStatus = 'active';
            data.documentStatus = 'active';
            if (!data.documentTag2) {
                data.documentTag2 = '110';
            }
            return basicService.send(api, data, 'GET')
        };

        this.getById = function (documentId) {
            var api = '/public/document/detail/' + documentId;
            return basicService.send(api, {}, 'GET')
        };

        this.relation = {
            getList: function (offset, limit, data) {
                var api = '/public/relation/list/' + offset + '/' + limit;
                return basicService.send(api, data, 'GET')
            }
        };

    }
);

'use strict';

angular.module('app').service('basicService',
    function ($http, config, $q, $timeout) {
        this.send = function (api, data, method, noParam) {
            method = method || 'POST';
            var defer = $q.defer();
            if (method.toUpperCase() == 'GET' && data && $.param(data)) {
                api += '?' + $.param(data)
            }
            $http({
                method: method,
                url: config.apiHost + api,
                data: noParam ? data : $.param(data),
                headers: noParam ? {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=utf-8'
                } : {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                }
            }).success(function (data) {
                defer.resolve(data);
            }).error(function (data, status) {
                if ((status != 401 && status != 403) || api.indexOf('/oauth/token') > -1) {
                    defer.reject(data)
                }
            });
            return defer.promise;
        };
    }
);

'use strict';

angular.module('app').service('communityService',
    function (basicService) {

        this.add = function (data) {
            var api = '/user/community/add';
            return basicService.send(api, data)
        };

        this.update = function (data) {
            var api = '/user/community/update';
            return basicService.send(api, data)
        };

        this.getInfo = function () {
            var api = '/user/community/info';
            return basicService.send(api, {}, 'GET')
        };

    }
);

'use strict';

angular.module('app').service('httpInterceptor',
    function ($q, $rootScope, localStorageService) {
        return {
            'request': function (config) {
                if (localStorageService.get("token")) {
                    //config.headers['Content-Type'] = "application/x-www-form-urlencoded;charset=utf-8";
                    config.headers['Authorization'] = "Bearer " + localStorageService.get("token");
                }
                return config;
            },
            'requestError': function (rejection) {
                return $q.reject(rejection);
            },
            'response': function (response) {
                return response;
            },
            'responseError': function (rejection) {
                 if (rejection.config.url.indexOf('/oauth/token') > -1) {
                     return $q.reject(rejection);
                 }
                if (rejection.status == 401 || rejection.status == 403) {
                    layer.msg('请先登陆，以便我们为您提供更好的服务。');
                    $rootScope.$broadcast('loginOverTime');
                    localStorageService.clearAll();
                    $rootScope.$state.go('login');
                }
                 else if (rejection.status == 502) {
                    layer.msg('服务器未知错误', {icon: 5});
                    $rootScope.$broadcast('loginOverTime');
                    localStorageService.clearAll();
                    $rootScope.$state.go('login');
                } else if (rejection.status == 0) {
                    $rootScope.$broadcast('loginOverTime');
                    localStorageService.clearAll();
                    $rootScope.$state.go('login');
                }
                return $q.reject(rejection);
            }
        };
    }
);


'use strict';
angular.module('app').service('layerService',
    function ($q) {
        this.confirm = function (title, content, btn, theme) {
            btn = btn || [];
            theme = theme || 'red';
            btn[0] = btn[0] || '确定';
            btn[1] = btn[1] || '取消';
            var defer = $q.defer();
            layer.open({
                title: title,
                content: content,
                btn: btn,
                closeBtn: 0,
                skin: theme,
                yes: function (index, layero) {
                    layer.closeAll();
                    defer.resolve();
                },
                cancel: function () {
                    defer.reject();
                },
                btn2: function () {
                    defer.reject();
                }
            });
            return defer.promise;
        };
    }
);
'use strict';
angular.module('app').service('cookiesService',
    function () {
        this.set = function (key, value, path, expires) {
            expires = expires || 24;
            path = path || '/';
            var date = new Date();
            date.setTime(date.getTime() + expires * 3600 * 1000);
            //document.cookie = key + "=" + escape(value) + ";path=" + path + ";expires=" + date.toGMTString();
            document.cookie = key + "=" + value + ";path=" + path + ";expires=" + date.toGMTString();
        };
    }
);
'use strict';

angular.module('app').service('oprlogService',
    function (basicService) {
        this.getList = function (offset, limit, data) {
            var api = '/public/oprlog/list/' + offset + '/' + limit;
            return basicService.send(api, data, 'GET')
        };
        this.add = function (data) {
            var api = '/public/oprlog/pv/add';
            return basicService.send(api, data)
        };
    }
);

'use strict';

angular.module('app').service('relationService',
    function (basicService) {
        this.getList = function (offset, limit, data) {
            var api = '/public/relation/list/' + offset + '/' + limit;
            return basicService.send(api, data, 'GET');
        };
        this.getById = function (relationId) {
            var api = '/public/relation/detail/' + relationId;
            return basicService.send(api, {}, 'GET');
        };
        this.add = function (data) {
            var api = '/user/relation/add';
            return basicService.send(api, data);
        };
        this.del = function (relationId) {
            var api = '/user/relation/del/' + relationId;
            return basicService.send(api, {}, 'GET');
        };
    }
);

'use strict';

angular.module('app').service('tokenService',
    function (basicService) {
        this.getToken = function (username, password) {
            var api = '/oauth/token';
            var data = {
                'grant_type': 'password',
                'client_id': 'my-trusted-client-with-secret',
                'client_secret': 'somesecret',
                'username': username,
                'password': password
            };
            return basicService.send(api, data)
        };
    }
);

'use strict';

angular.module('app').service('userService',
    function (basicService) {
        this.pwd = function (data) {
            var api = '/common/user/pwd';
            return basicService.send(api, data)
        };

        this.getInfo = function () {
            var api = '/common/user/info';
            return basicService.send(api, {}, 'GET')
        };

        this.update = function (data) {
            var api = '/common/user/info/update';
            return basicService.send(api, data)
        };

        this.reg = function (data) {
            var api = '/public/user/reg';
            return basicService.send(api, data)
        };

        this.sendMail = function (userName) {
            var api = '/public/user/sendmail/' + userName;
            return basicService.send(api, {}, 'GET')
        };

        this.setPwd = function (data) {
            var api = '/public/user/pwd';
            return basicService.send(api, data)
        };

        this.getMessageCode = function (data) {
            var api = '/public/user/reg/sendCode';
            return basicService.send(api, {
                mobileId:data.mobileId,
                verifyCode:data.verifyCode,
                isReg:data.isReg
            })
        };

        this.getPasswordCode = function (mobileId) {
            var api = '/public/user/sendsms/' + mobileId;
            return basicService.send(api, {}, 'GET')
        }
        //获取
        this.getSecurityCode = function(){
            var api = '/public/user/sendsms/' + mobileId;
            return basicService.send(api, {}, 'GET')
        }
        //获取注册页面验证码图片
        this.getCheckCode = function(){
            var api = '/public/user/cha/'
            return basicService.send(api, {}, 'GET')
        }
    }
);

'use strict';

angular.module('app').service('venderService',
    function (basicService) {
        this.getList = function (offset, limit, data) {
            var api = '/public/vender/list/' + offset + '/' + limit;
            data.venderStatus = 'active';
            return basicService.send(api, data, 'GET');
        };

        this.getById = function (documentId) {
            var api = '/public/vender/detail/' + documentId;
            return basicService.send(api, {}, 'GET');
        };

        this.getInfo = function () {
            var api = '/user/vender/info';
            return basicService.send(api, {}, 'GET')
        };

    }
);

/**
 * Created by lxp on 2016/7/19.
 */
'use strict';

angular.module('app')
  .filter('defaultAvatar', function () {
    return function (input) {
      return input || 'assets/images/avatar-default.png';
    };
  });

/**
 * Created by lxp on 2016/7/19.
 */
'use strict';

angular.module('app').filter('fromNow',
	function () {
		return function (input) {
			var str = moment(input).fromNow();
			if (str.substring(str.length - 1, str.length) == '前') {
				return '已结束';
			} else {
				return str;
				//return str.substring(0, str.length - 1);
			}
		};
	}
);

/**
 * Created by lxp on 2016/7/19.
 */
'use strict';

angular.module('app').filter('indexImg',
    function (config) {
        var defaultImg = 'assets/images/vender-default.jpg';
        return function (input, value) {
            if (!input) {
                return defaultImg;
            } else {
                var arr = input.split(',');
                return arr[value] || defaultImg;
            }
        };
    }
);

/**
 * Created by lxp on 2016/7/19.
 */
'use strict';

angular.module('app').filter('img',
	function (config) {
		return function (input, value) {
			if (!input) {
				if (!value) {
					value = 'noImg2.jpg';
				}
				return 'assets/images/' + value;
			}
			if (input.indexOf('http://') != -1) {
				return input;
			}
			return config.imgHost + input;
		};
	}
);

'use strict';
angular.module('app').directive('activityAside',
    function ($rootScope, config, util) {
        return {
            templateUrl: 'app/directives/activityAside/activityAside.html',
            scope: {
                eventList: '=activityAside',
            },
            link: function ($scope, element, attr) {
                $scope.activityCategoryList = config.activityCategoryList;
                $scope.activityTypeList = config.activityTypeList;
                $scope.venderTypeList = config.venderTypeList;
                $scope.activityTagList = config.activityTagList;

                $scope.activityValidList = [{
                    name: '全部状态',
                    value: 0
                }, {
                    name: '可预约',
                    value: 1
                }, {
                    name: '不可预约',
                    value: 2
                }];

                $scope.search = util.deserialize($rootScope.$stateParams.search);
                if ($scope.search.time) {
                    $scope.currentDate = $scope.search.time + ' 00:00:00';
                }

                $scope.change = function () {
                    //$scope.submit();
                };

                $scope.submit = function () {
                    if (!($scope.search.veT * 1)) {
                        delete $scope.search.veT;
                    }
                    if (!($scope.search.acV * 1 == 1 || $scope.search.acV * 1 == 2)) {
                        delete $scope.search.acV;
                    }
                    if (!($scope.search.acT * 1)) {
                        delete $scope.search.acT;
                    }
                    if (!($scope.search.acC * 1)) {
                        delete $scope.search.acC;
                    }
                    if (!($scope.search.acTa * 1)) {
                        delete $scope.search.acTa;
                    }
                    $rootScope.$state.go('activity.list', {
                        search: util.serialize($scope.search),
                        pageNum: 1
                    });
                };

            }
        };
    }
);

'use strict';
angular.module('app').directive('banner',
    function ($rootScope) {
        return {
            templateUrl: 'app/directives/banner/banner.html',
            scope: {
                banner: '='
            },
            link: function ($scope, element, attr) {
                $scope.img = $scope.banner;
            }
        };
    }
);

'use strict';
var Calendar = function (element, data, date, currentDate) {
    this.element = $(element);
    this.date = date || new Date();
    this.data = data || [];
    this.currentDate = new Date(currentDate);
};
Calendar.prototype.init = function () {
    var self = this;
    this.element.addClass("calendar");
    this.getDom();

    this.body = new Calendar.Body(this.element.find(".calendar_body"), this.date, this.data, this.currentDate);
    this.header = new Calendar.Header(this.element.find(".calendar_header"), this.date, function (inc) {
        self.body.scrollTo(inc, 500, function () {
            self.date.setMonth(self.date.getMonth() + inc, 1);
            self.setDate(self.date);
        });
    }, function (date) {
        self.selectDate(date);
    });
    this.footer = new Calendar.Footer(this.element.find(".calendar_footer"), this.date);
    this.aside = new Calendar.Aside(this.element.find(".calendar_aside"), this.date, function (date) {
        self.setDate(date);
    });
    this.setDate(this.date);
    //---修复ie6兼容
    this.element.find(".calendar_aside").css("height", this.element.height());
};
Calendar.prototype.getDom = function () {
    var temp = "";
    temp += "<div class='calendar_header'></div>";
    temp += "<div class='calendar_body'><div class='bodyContent'><div class='list'></div></div></div>";
    temp += "<div class='calendar_footer'></div>";
    temp += "<div class='calendar_aside' style='display: none'></div>";
    this.element.html(temp);
};
Calendar.prototype.selectDate = function (type) {
    this.aside.focusOpen(type);
};
Calendar.prototype.setData = function (value) {
    this.body.setData(value);
    this.setDate(this.date);
};
Calendar.prototype.setDate = function (date) {
    //this.date.setTime(date.getTime());
    this.date = date;
    this.header.setDate(this.date);
    this.body.setDate(this.date);
    this.footer.setDate(this.date);
    this.aside.setDate(this.date);
};


/*
 * Calendar.Header-------------------------------------------------------
 * */
Calendar.Header = function (element, date, setDatehandler, selectDateHandler) {
    this.element = element;
    this.date = date;
    this.setDatehandler = setDatehandler;
    this.selectDateHandler = selectDateHandler;
    this.init();
};
Calendar.Header.prototype.init = function () {
    var self = this;
    this.element.on("click", ".prev_btn", function (ev) {
        self.setDatehandler(-1);
    });
    this.element.on("click", ".next_btn", function (ev) {
        self.setDatehandler(1);
    });
    this.element.on("click", ".year", function (ev) {
        self.selectDateHandler("year");
    });
    this.element.on("click", ".month", function (ev) {
        self.selectDateHandler("month");
    })
};
Calendar.Header.prototype.getDom = function () {
    var temp = "";
    temp += "<div class='titlebar'>";
    temp += "   <a class='prev_btn btn'>&lt;</a>";
    temp += "   <div class='title'>";
    temp += "       <span class='year'><a>" + this.date.getFullYear() + "</a></span>";
    temp += "       <span class='label'>年</span>";
    temp += "       <span class='month'><a>" + (this.date.getMonth() + 1) + "</a></span>";
    temp += "       <span class='label'>月</span>";
    temp += "   </div>";
    temp += "   <a class='next_btn btn'>&gt;</a>";
    temp += "</div>";
    temp += "<div class='monthList'><table cellspacing='0' cellpadding='0'><tr>";
    temp += "   <td>日</td>";
    temp += "   <td>一</td>";
    temp += "   <td>二</td>";
    temp += "   <td>三</td>";
    temp += "   <td>四</td>";
    temp += "   <td>五</td>";
    temp += "   <td>六</td>";
    temp += "</tr></table></div>";
    this.element.html(temp);
};
Calendar.Header.prototype.setDate = function (date) {
    this.date = date;
    this.getDom();
};

/*
 * Calendar.Body-------------------------------------------------------
 * */

Calendar.Body = function (element, date, data, currentDate) {
    this.element = element;
    this.date = date;
    this.data = data;
    this.currentDate = currentDate;
    this.init();
};
Calendar.Body.prototype.init = function () {
    var self = this;
    this.bodyContent = this.element.find(".bodyContent");
    this.list = this.bodyContent.find(".list");
    this.scrollEv = false;
    this.element.on("click", "a", function (ev) {
        self.clickHandler(ev)
    })
};
Calendar.Body.prototype.getDom = function () {
    var cDate = new Date();
    var date = new Date(this.date);
    date.setMonth(date.getMonth() - 1, 1);

    var temp = "";
    for (var loop = 0; loop < 3; loop++) {
        var getFullYear = date.getFullYear();
        var getMonth = date.getMonth();
        var total = new Date(getFullYear, getMonth + 1, 0).getDate();
        var prevTotal = new Date(getFullYear, getMonth, 0).getDate();
        var day = new Date(getFullYear, getMonth, 1).getDay();
        day == 0 ? day = 7 : 1;

        temp += "<table style='width:" + this.bodyContent.width() + "px' cellspacing='1' cellpadding='0'><tr>";
        //--上月日期
        for (var i = (prevTotal - day + 1), j = 0; i <= prevTotal; i++, j++) {
            if (j % 7 == 0 && j != 0) {
                temp += "</tr><tr>";
            }
            temp += "<td class='disable'>" + i + "</td>";
        }
        //--当月日期
        for (i = 1; i <= total; i++, j++) {
            if (j % 7 == 0) {
                temp += "</tr><tr>";
            }
            //分析data数据，生成mark
            var mark = "";
            var dateMark = "";
            var key = getFullYear + "/" + (getMonth + 1) + "/" + i;
            if (this.data[key] != undefined) {
                if (this.data[key].constructor == Function) {
                    mark += "<div></div>";
                } else if (this.data[key].constructor == String) {
                    mark += "<div>" + this.data[key] + "</div>";
                } else if (this.data[key].constructor == Array) {
                    mark += "<div>" + this.data[key][0] + "</div>";
                }
                dateMark = "date='" + key + "'";
            }
            var className = "class='";
            //---配备对应日期
            if (i == cDate.getDate() && cDate.toLocaleDateString() == date.toLocaleDateString()) {
                className += "toady";
            }
            if (this.currentDate && i == this.currentDate.getDate() && this.currentDate.getFullYear() == date.getFullYear() && this.currentDate.getMonth() == date.getMonth()) {
                className += " current";
            }
            className += "'";
            temp += "<td " + className + " " + dateMark + "><a>" + i + "</a>" + mark + "</td>";
        }
        //--下月日期
        for (i = 1; j < 42; i++, j++) {
            if (j % 7 == 0) {
                temp += "</tr><tr>";
            }
            temp += "<td class='disable'>" + i + "</td>";
        }
        temp += "</tr></table>";

        date.setMonth(date.getMonth() + 1, 1);
    }
    this.list.html(temp);
};
Calendar.Body.prototype.clickHandler = function (ev) {
    var key = $(ev.target).parent().attr("date");
    if (key == undefined) {
        return;
    }
    if (this.data[key].constructor == Function) {
        this.data[key]();
    } else if (this.data[key].constructor == Array) {
        if (this.data[key][1].constructor == Function) {
            this.data[key][1](this.data[key][0]);
        }
    }
    this.currentDate = new Date(key);
    $(ev.target).parents("table").find("td").removeClass("current");
    $(ev.target).parent().addClass("current");
};
Calendar.Body.prototype.scrollTo = function (inc, time, fn) {
    var self = this;
    if (this.scrollEv == false) {
        this.scrollEv = true;
        this.bodyContent.animate({scrollLeft: this.bodyContent.width() * (1 + inc)}, time, function () {
            self.scrollEv = false;
            if (fn != undefined)fn();
        })
    }
};
Calendar.Body.prototype.setData = function (value) {
    this.data = value;
};
Calendar.Body.prototype.setDate = function (date) {
    this.date = date;
    this.getDom();
    this.scrollTo(0, 0)
};

/*
 * Calendar.Footer-------------------------------------------------------
 * */

Calendar.Footer = function (element, date) {
    this.element = element;
    this.date = date;
    this.init();
};
Calendar.Footer.prototype.init = function () {
};
Calendar.Footer.prototype.getDom = function () {
    var temp = "";
    temp += this.date.toLocaleDateString();
    this.element.html(temp);
};
Calendar.Footer.prototype.setDate = function (date) {
    this.date = date;
    this.getDom();
};

/*
 * Calendar.Aside-------------------------------------------------------
 * */
Calendar.Aside = function (element, date, setDateHandler) {
    this.element = element;
    this.date = date;
    this.setDateHandler = setDateHandler;
    this.year = null;
    this.month = null;
    this.init();
};
Calendar.Aside.prototype.init = function () {
    var self = this;
    this.element.on("click", ".select_year a", function (ev) {
        self.clickHandler(ev, "year");
    });
    this.element.on("click", ".select_month a", function (ev) {
        self.clickHandler(ev, "month");
    })
};
Calendar.Aside.prototype.getDom = function () {
    var temp = "";
    temp += "<div class='select_year' style='display: none'><table cellspacing='1' cellpadding='0'>";
    var currentYear = this.date.getFullYear() * 1;
    var year = currentYear - 12;
    for (var i = 0; i < 5; i++) {
        temp += "<tr>";
        for (var j = 0; j < 5; j++, year++) {
            if (currentYear == year) {
                temp += "<td class='current'><a><span>" + year + "</span><i></i></a></td>"
            } else {
                temp += "<td><a><span>" + year + "</span><i></i></a></td>"
            }
        }
        temp += "</tr>";
    }
    temp += "</table></div>";
    temp += "<div class='select_month' style='display: none'><table cellspacing='1' cellpadding='0'>";
    var currentDay = this.date.getMonth() + 1;
    var day = 1;
    for (i = 0; i < 4; i++) {
        temp += "<tr>";
        for (var j = 0; j < 3; j++, day++) {
            if (currentDay == day) {
                temp += "<td class='current'><a><span>" + day + "</span><i></i></a></td>"
            } else {
                temp += "<td><a><span>" + day + "</span><i></i></a></td>"
            }
        }
        temp += "</tr>";
    }
    temp += "</table></div>";
    this.element.html(temp);
};
Calendar.Aside.prototype.focusOpen = function (type) {
    this.getDom();
    if (type == "month") {
        this.element.find(".select_year").css("display", "none");
        this.element.find(".select_month").css("display", "block");
    } else {
        this.element.find(".select_year").css("display", "block");
        this.element.find(".select_month").css("display", "none");
    }
    this.element.animate({opacity: 'show'}, 300);
};
Calendar.Aside.prototype.focusClose = function () {
    this.element.animate({opacity: 'hide'}, 300);
};
Calendar.Aside.prototype.clickHandler = function (ev, type) {
    if (type == "month") {
        this.date.setMonth($(ev.currentTarget).find('span').html() - 1, 1);
    } else {
        this.date.setFullYear($(ev.currentTarget).find('span').html());
    }
    this.setDateHandler(this.date);
    this.focusClose();
};
Calendar.Aside.prototype.setDate = function (date, type) {
    this.date = date;
    this.getDom();
};

angular.module('app').directive('calendar',
    function ($rootScope) {
        return {
            templateUrl: 'app/directives/calendar/calendar.html',
            scope: {
                events: '=',
                current: '=?'
            },
            link: function ($scope, element, attr) {
                $scope.events = $scope.events || [];
                var current = null;
                if ($scope.current) {
                    current = new Date($scope.current);
                }
                var calendar = new Calendar(element, $scope.events, current, current);
                calendar.init();
            }
        };
    }
);

'use strict';
angular.module('app').directive('columnLocation',
    function ($rootScope, config) {
        return {
            templateUrl: 'app/directives/columnLocation/columnLocation.html',
            scope: {
                locations: '=columnLocation'
            },
            link: function ($scope, element, attr) {
                $scope.getTrsUrl = function (url) {
                    return config.trsHost + url;
                };
            }
        };
    }
);

'use strict';
angular.module('app').directive('columnTitleBar',
    function ($rootScope) {
        return {
            templateUrl: 'app/directives/columnTitleBar/columnTitleBar.html',
            scope: {
                bg: '@columnTitleBar',
                locations: '='
            },
            link: function ($scope, element, attr) {
                $scope.style = {
                    "background-image": "url(" + $scope.bg + ")"
                }
            }
        };
    }
);

'use strict';
angular.module('app').directive('customSelect',
    function ($rootScope, $timeout) {
        return {
            templateUrl: 'app/directives/customSelect/customSelect.html',
            scope: {
                list: '=options',
                change: '&?'
            },
            require: '?ngModel',
            link: function ($scope, element, attr, ctrl) {
                var list = element.find('.list');
                var openEv = false;
                var clickSelf = false;
                ctrl && (ctrl.$render = function () {
                    if (!ctrl.$isEmpty(ctrl.$viewValue)) {
                        $scope.value = ctrl.$viewValue;
                        for (var i = 0; i < $scope.list.length; i++) {
                            if ($scope.list[i].value == $scope.value) {
                                $scope.current = $scope.list[i];
                                break;
                            }
                        }
                    } else {
                        $scope.current = $scope.list[0];
                        $scope.value = $scope.current.value;
                    }
                });
                $scope.checked = function (item, event) {
                    event.stopPropagation();
                    $scope.value = item.value;
                    $scope.current = item;
                    ctrl && ctrl.$setViewValue(item.value);
                    $scope.close();
                    $scope.change && $scope.change();
                };
                $scope.open = function (event) {
                    clickSelf = $(event.target).parents('.customSelect').parents('div').eq(0).is(element);
                    openEv = true;
                    list.css('border-bottom-width', 1);
                    list.animate({height: (list.find('.item').eq(0).height() || 0) * $scope.list.length}, 300)
                };

                $scope.close = function () {
                    openEv = false;
                    list.css('border-bottom-width', 0);
                    list.animate({height: 0}, 200)
                };
                var clickHandler = function () {
                    if (clickSelf) {
                        clickSelf = false;
                        return;
                    }
                    if (openEv) {
                        $timeout(function () {
                            $scope.close();
                        })
                    }
                };
                $(document).on('click', clickHandler);
                $scope.$on('$destroy', function () {
                    $(document).off('click', clickHandler);
                });
            }
        };
    }
);

'use strict';
angular.module('app').directive('imgCode',
    function ($rootScope, config) {
        return {
            templateUrl: 'app/directives/imgCode/imgCode.html',
            scope: {},
            require: '?ngModel',
            link: function ($scope, element, attr, ctrl) {
                $scope.curentCode = {};

                var currentIndex = 0;
                var setCurrentCode = function () {
                    var temp = {};
                    var random = Math.floor(Math.random() * config.imgCodes.length);
                    if (currentIndex != random) {
                        currentIndex = random;
                        temp = {
                            img: 'assets/images/' + config.imgCodes[currentIndex].img,
                            code: config.imgCodes[currentIndex].code,
                        };
                        ctrl && ctrl.$setViewValue(temp.code);
                    } else {
                        temp = setCurrentCode();
                    }
                    return temp;
                };

                ctrl && (ctrl.$render = function () {
                    if (!ctrl.$isEmpty(ctrl.$viewValue)) {
                        for (var i = 0; i < config.imgCodes.length; i++) {
                            if (config.imgCodes[i].code == ctrl.$viewValue) {
                                currentIndex = i;
                                $scope.curentCode = config.imgCodes[i];
                                break;
                            }
                        }
                    }
                    if (!$scope.curentCode.code) {
                        $scope.curentCode = setCurrentCode();
                    }
                });

                $scope.clickHandler = function () {
                    $scope.curentCode = setCurrentCode();
                }
            }
        };
    }
);

'use strict';
angular.module('app').directive('messageCode',
    function ($rootScope, config, $interval, userService,layerService) {
        return {
            templateUrl: 'app/directives/messageCode/messageCode.html',
            scope: {
                mobileId: '=',
                type: '@?',
                isReg: '@?'
            },
            require: '?ngModel',
            link: function ($scope, element, attr, ctrl) {
                $scope.random = Math.random();
                $scope.otherData = {};

                $scope.clickHandler = function () {
                    if ($scope.otherData.waiting) return;
                    if (!$scope.mobileId) {
                        layer.msg('请先输入您的手机号码', {icon: 5, time: 1000});
                        return;
                    }
                    $scope.otherData.waiting = true;
                    $scope.delayTime();
                    //要求输入验证码
                    layer.open({
                        type: 1,
                        shade: false,
                        closeBtn: 1,
                        title: '请输入验证码', 
                        content: $('.layer_notice')
                    });
                }

                $scope.change = function(){
                    $scope.random = Math.random();
                }

                $scope.delayTime = function(){
                    $scope.otherData.date = 60;
                    var stop = $interval(function () {
                        $scope.otherData.date--;
                        if ($scope.otherData.date === 0) {
                            $interval.cancel(stop);
                            $scope.otherData.waiting = false;
                            $scope.change();
                        }
                    }, 1000);
                }

                //获取电话验证
                $scope.getImgCode = function(){
                    var promise = userService.getMessageCode;
                    var data = {
                        mobileId:$scope.mobileId,
                        verifyCode:$scope.verifyCode,
                        isReg:$scope.isReg
                    }
                    promise(data).then(function (data) {
                        if(data.status == -1){
                            layer.alert(data.statusDesc);
                        }else{
                            //$scope.time();
                            ctrl.$setViewValue(data.result);
                            layer.closeAll();
  
                        }

                    },function(data){
                        layer.closeAll();
                        layer.alert("错误！");
                        //$scope.time();
                    });

                     $scope.$on('$destroy', function () {
                        if (stop) {
                            $interval.cancel(stop);
                        }
                    });
                }
            }
        };
    }
);

'use strict';
angular.module('app').directive('pageFooter',
    function ($rootScope) {
        return {
            templateUrl: 'app/directives/pageFooter/pageFooter.html',
            scope: {},
            link: function ($scope, element, attr) {

            }
        };
    }
);

'use strict';
angular.module('app').directive('pageHeader',
    function ($rootScope, $state, localStorageService, util, config) {
        return {
            templateUrl: 'app/directives/pageHeader/pageHeader.html',
            scope: {},
            link: function ($scope, element, attr) {
                $scope.search = {};

                $scope.userId = localStorageService.get('userId');
                $scope.trueName = localStorageService.get('trueName') || '暂无实名';

                $scope.getTrsUrl = function (url) {
                    return config.trsHost + url;
                };

                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    $scope.name = $state.current.name;
                    $scope.search = util.deserialize($rootScope.$stateParams.search);
                });

                $scope.exit = function () {
                    localStorageService.clearAll();
                    $rootScope.$broadcast('getInfoSuccess');
                    $rootScope.$state.go('login');
                };

                $scope.$on('getInfoSuccess', function () {
                    $scope.userId = localStorageService.get('userId');
                    $scope.userName = localStorageService.get('userName') || '暂无实名';
                });

                $scope.$on('loginOverTime', function () {
                    $scope.userId = '';
                    $scope.userName = '';
                });

                $scope.goActivityList = function (value) {
                    $rootScope.$state.go('activity.list', {
                        search: util.serialize({
                            acC: value
                        }),
                        pageNum: 1
                    });
                };

                $scope.submit = function () {
                    var selectType = localStorageService.get('selectType') || 0;
                    if (selectType == 0) {
                        $rootScope.$state.go('activity.list', {
                            search: util.serialize($scope.search),
                            pageNum: 1
                        });
                    } else if (selectType == 1) {
                        $rootScope.$state.go('vender.search', {
                            search: util.serialize($scope.search),
                            pageNum: 1
                        });
                    } else if (selectType == 2) {
                        util.formPost('http://218.69.114.24:8080/was40/search', [
                            {name: 'channelid', value: '45068'},
                            {name: 'searchword', value: $scope.search.acN}])
                    }
                };

                $scope.goUserPage = function () {
                    if (localStorageService.get('userType') == 'community') {
                        $rootScope.$state.go('user.auth')
                    } else {
                        $rootScope.$state.go('user')
                    }
                };

                /*
                 * 采用jquery解决方案，以便trs那边可以直接使用
                 * */
                var select = element.find('.select');
                var items = element.find('.select .item');
                var current = element.find('.select .current');
                var list = element.find('.select .list');
                var selectType = localStorageService.get('selectType') || 0;
                items.map(function () {
                    if ($(this).attr('data-value') == selectType) {
                        $(this).addClass('active');
                        current.find('span').html($(this).html());
                    }
                });
                select.on('mouseleave', function () {
                    list.css('display', 'none');
                });
                current.on('click', function () {
                    list.css('display', 'block');
                });
                items.on('click', function () {
                    $(this).siblings().removeClass('active');
                    $(this).addClass('active');
                    list.css('display', 'none');
                    current.find('span').html($(this).html());
                    localStorageService.set('selectType', $(this).attr('data-value'))
                })
            }
        };
    }
);

'use strict';
angular.module('app').directive('tabs',
    function () {
        return {
            templateUrl: 'app/directives/tabs/tabs.html',
            restrict: 'AE',
            transclude: true,
            controllerAs: 'tabsCtrl',
            controller: ['$scope', function ($scope) {
                var self = this;
                this.tabs = [];
                this.addTab = function (item) {
                    this.tabs.push(item);
                };
                this.select = function (selectedTab) {
                    for (var i = 0; i < self.tabs.length; i++) {
                        self.tabs[i].active = false;
                    }
                    selectedTab.active = true;
                    if (selectedTab.click) {
                        selectedTab.click();
                    }
                }
            }],
            link: function ($scope) {

            }
        };
    }
);

'use strict';
angular.module('app').directive('upload',
    function (config, $timeout) {
        return {
            templateUrl: function (element, attr) {
                if (attr.max && attr.max > 1) {
                    return 'app/directives/upload/multiple/multiple.html';
                } else {
                    return 'app/directives/upload/single/single.html';
                }
            },
            restrict: 'AE',
            replace: true,
            transclude: true,
            scope: {
                width: '@?',
                height: '@?',
                type: '@?',
                size: '@?',
                max: '@?'
            },
            require: '?ngModel',
            link: function ($scope, element, attr, ctrl) {
                /*
                 * 注：若出现拖动排序时错位问题，
                 * 注销掉bower_components/jquery-ui/jquery-ui.js
                 * po.top += this.scrollParent.scrollTop(); //16304行
                 *
                 * */

                //错误提示内容
                $scope.errorInfo = '';
                //图片数组
                $scope.imgs = [];
                //上传标识
                $scope.uploading = false;
                //当前上传进度
                $scope.uploadProgress = 0;
                //默认'jpg', 'png', 'jpeg'格式
                $scope.type = ($scope.type && $scope.type.split(',')) || ['JPG', 'PNG', 'JPEG'];
                //默认允许上传1张
                $scope.max = $scope.max || 1;
                var max = $scope.max || 1;
                //默认1M
                $scope.size = $scope.size || 1;
                //默认显示图片大小 X*100
                $scope.sizeStyle = {
                    width: (function () {
                        if ($scope.width && $scope.height) {
                            return ($scope.width * 100 / $scope.height).toFixed(0)
                        }
                        return 100;
                    })(),
                    height: 100
                };

                ctrl && (ctrl.$render = function () {
                    if (ctrl.$viewValue) {
                        if (ctrl.$viewValue instanceof Array) {
                            $scope.imgs = ctrl.$viewValue;
                        } else if (ctrl.$viewValue.constructor == String) {
                            if (ctrl.$viewValue != "undefined") {
                                $scope.imgs = ctrl.$viewValue.split(',');
                            }
                        }
                    } else {
                        ctrl.$setViewValue('');
                    }
                });

                $scope.delImg = function ($index) {
                    $scope.imgs.splice($index, 1);
                    ctrl && ctrl.$setViewValue($scope.imgs.join(','));
                };

                var button = element.find('.uploadBtn')[0];
                button.id = button.id ? button.id : "qiniu_" + (Date.now()) + Math.round(Math.random() * 10000);
                var uploader = Qiniu.uploader({
                    runtimes: 'html5,flash,html4',
                    browse_button: button.id,
                    uptoken: config.qiniuToken,
                    unique_names: true,
                    domain: config.qiniuDomain,
                    max_file_size: '100mb',
                    flash_swf_url: 'plupload/Moxie.swf',
                    max_retries: 3,
                    dragdrop: false,
                    drop_element: 'container',
                    chunk_size: '4mb',
                    auto_start: true,
                    multi_selection: $scope.multi || false,
                    init: {
                        'FilesAdded': function (up, files) {
                            $timeout(function () {
                                $scope.errorInfo = '';
                                for (var i = 0; i < files.length; i++) {
                                    var file = files[i], type = file.name.substring(file.name.lastIndexOf('.') + 1);

                                    //判断图片类型
                                    if ($scope.type && $scope.type.indexOf(type.toUpperCase()) == -1) {
                                        up.removeFile(file);
                                        $scope.errorInfo = '选择文件格式错误，请上传' + $scope.type.join(',') + '格式文件';
                                    }

                                    //判断图片大小
                                    var size = file.size / 1024 / 1024;
                                    if (size > $scope.size) {
                                        up.removeFile(file);
                                        $scope.errorInfo = '您上传的大小为' + size.toFixed(2) + 'M，不符合要求';
                                        return;
                                    }
                                }
                            })
                        },
                        'BeforeUpload': function (up, file) {
                        },
                        'UploadProgress': function (up, file) {
                            $timeout(function () {
                                $scope.uploading = true;
                                $scope.uploadProgress = file.percent;
                            })
                        },
                        'FileUploaded': function (up, file, info) {
                            var info = JSON.parse(info);
                            $timeout(function () {
                                $scope.uploading = false;
                                $scope.uploadProgress = 0;

                                //判断图片尺寸
                                if ($scope.width && info.w != $scope.width) {
                                    $scope.errorInfo = '您上传的尺寸为' + info.w + '×' + info.h + '，不符合要求';
                                    return;
                                }

                                if ($scope.height && info.h != $scope.height) {
                                    $scope.errorInfo = '您上传的尺寸为' + info.w + '×' + info.h + '，不符合要求';
                                    return;
                                }
                                if ($scope.max == 1 || !$scope.max) {
                                    $scope.imgs = [config.qiniuDomain + info.key];
                                } else {
                                    $scope.imgs.push(config.qiniuDomain + info.key);
                                }
                                ctrl && ctrl.$setViewValue($scope.imgs.join(','));
                            })
                        },
                        'Error': function (up, err, errTip) {
                        },
                        'UploadComplete': function () {
                        },
                        'Key': function (up, file) {
                            var key = "";
                            return key
                        }
                    }
                });
            }
        };
    }
);

'use strict';
angular.module('app').directive('pagination',
	function ($rootScope) {
		return {
			templateUrl: 'app/directives/pagination/pagination.html',
			scope: {
				pageTotal: '=',
				pageChange: '=?',
				pageNum: '=?'
			},
			link: function ($scope, element, attr) {
				$scope.pagesLength = 9;
				if ($scope.pageChange) {
					$scope.pageCurrent = $scope.pageNum;
					$scope.$watch('pageNum', function (value) {
						if (value != $scope.pageCurrent) {
							$scope.pageCurrent = value;
						}
					});
				} else {
					$scope.pageCurrent = $rootScope.$stateParams.pageNum * 1;
				}
				$scope.gotoNum = $scope.pageCurrent;

				var goto = function () {
					if ($scope.pageChange) {
						getPageList();
						$scope.pageChange($scope.pageCurrent);
					} else {
						$rootScope.$state.go($rootScope.$state.current.name, {pageNum: $scope.pageCurrent})
					}
				};

				$scope.prevPage = function () {
					if ($scope.pageCurrent > 1) {
						$scope.pageCurrent -= 1;
						goto();
					}
				};

				$scope.nextPage = function () {
					if ($scope.pageCurrent < $scope.pageTotal) {
						$scope.pageCurrent += 1;
						goto();
					}
				};

				$scope.changePage = function (item) {
					if (item == '...') {
						return;
					} else {
						$scope.pageCurrent = item;
					}
					goto();
				};

				var getPageList = function () {
					$scope.pageCurrent *= 1;
					var pageList = [];
					if ($scope.pageTotal <= $scope.pagesLength) {
						for (var i = 1; i <= $scope.pageTotal; i++) {
							pageList.push(i);
						}
					} else {
						var offset = ($scope.pagesLength - 1) / 2;
						if ($scope.pageCurrent <= offset) {
							// 左边没有...
							for (var i = 1; i <= offset + 1; i++) {
								pageList.push(i);
							}
							pageList.push('...');
							pageList.push($scope.pageTotal);
						} else if ($scope.pageCurrent > $scope.pageTotal - offset) {
							// 右边没有...
							pageList.push(1);
							pageList.push('...');
							for (var i = offset + 1; i >= 1; i--) {
								pageList.push($scope.pageTotal - i);
							}
							pageList.push($scope.pageTotal);
						} else {
							// 最后一种情况，两边都有...
							pageList.push(1);
							pageList.push('...');

							for (var i = Math.ceil(offset / 2); i >= 1; i--) {
								pageList.push($scope.pageCurrent - i);
							}
							pageList.push($scope.pageCurrent);
							for (i = 1; i <= offset / 2; i++) {
								pageList.push($scope.pageCurrent + i);
							}

							pageList.push('...');
							pageList.push($scope.pageTotal);
						}
					}
					$scope.pageList = pageList;
				};
				$scope.$watch('pageTotal', function (newValue, oldValue) {
					getPageList();
				})
			}
		};
	}
);

'use strict';
angular.module('app').directive('userNav',
    function ($rootScope, localStorageService) {
        return {
            templateUrl: 'app/directives/userNav/userNav.html',
            scope: {
                name: '@userNav'
            },
            link: function ($scope, element, attr) {
                $scope.userType = localStorageService.get('userType');
                $rootScope.userInfo().then(function (data) {
                    var authorities = data.supplement.authorities;
                    for (var i = 0; i < authorities.length; i++) {
                        if (authorities[i].authority === 'ROLE_BUSINESS') {
                            $scope.communityAdmin = true;
                            break;
                        }
                    }

                });
            }
        };
    }
);

'use strict';
angular.module('app').directive('userAvatar',
    function ($rootScope) {
        return {
            templateUrl: 'app/directives/userAvatar/userAvatar.html',
            scope: {},
            require: '?ngModel',
            transclude: true,
            link: function ($scope, element, attr, ctrl) {
                $scope.avatars = [];
                $rootScope.userInfo().then(function (data) {
                    if (data.result.userType == 'user') {
                        $scope.avatars = [
                            "assets/images/o_1bi361h7h1p8614c81a2p1748viv7.png",
                            "assets/images/o_1bi36200s17ah1mc2nde1vjv1otjc.png",
                            "assets/images/o_1bi3629iiht98shddr1q9u1l33h.png",
                            "assets/images/o_1bi362hrh2oo319fv14p51ea9m.png"
                        ];
                    } else if (data.result.userType == 'community') {
                        $scope.avatars = [
                            "assets/images/o_1bi36s96c1pa91a2lct7qj63i17.jpg",
                            "assets/images/o_1bi36sm5t1nfskb1nvkova3b0c.jpg"
                        ];
                    }

                    //初始化用户头像
                    ctrl && (ctrl.$render = function () {
                        if (!ctrl.$isEmpty(ctrl.$viewValue)) {
                            $scope.current = ctrl.$viewValue;
                        } else {
                            $scope.current = $scope.avatars[0];
                            ctrl && ctrl.$setViewValue($scope.current);
                        }
                    });
                });

   
                //更新头像，并更新controller中的data.userAvatar
                $scope.selected = function (item) {
                    $scope.current = item;
                    ctrl && ctrl.$setViewValue(item);
                }
            }
        };
    }
);

'use strict';
angular.module('app').directive('tab',
    function () {
        return {
            templateUrl: 'app/directives/tabs/tab/tab.html',
            restrict: 'AE',
            transclude: true,
            require: '^tabs',
            scope: {
                title: '@?',
                click: '&?'
            },
            replace: true,
            link: function ($scope, $element, $attr, $ctrl) {
                $scope.active = $ctrl.tabs.length == 0;
                $ctrl.addTab($scope)
            }
        };
    }
);

'use strict';

angular.module('app').controller('activityController',
    function ($rootScope, $scope, localStorageService, config, relationService, initData, util) {
        $scope.data = {};
        $scope.otherData = {};
        var search = util.deserialize($rootScope.$stateParams.search);

        $scope.eventList = {};
        var timeClickHandler = function (date) {
            if (search.time && search.time == date) {
                delete search.time;
                delete search.month;
            } else {
                search.time = date;
                if (date.split('-')[1] * 1 == (new Date()).getMonth() + 1) {
                    search.month = 'current';
                } else {
                    search.month = 'next';
                }
            }
            $rootScope.$state.go('activity.list', {
                search: util.serialize(search),
                pageNum: 1
            });
        };

        $.map(initData.result, function (item, index) {
            var date = item.documentStartTime.substring(0, 10);
            var arr = date.split('-');
            $scope.eventList[arr[0] * 1 + '/' + arr[1] * 1 + '/' + arr[2] * 1] = [date, timeClickHandler];
        });
    }
);

'use strict';

angular.module('app').controller('kptjController',
    function ($rootScope, $scope, tokenService, localStorageService, userService, layerService, config) {
       
        $scope.data = {
            userType: 'user'
        };
        $scope.otherData = {};
        $scope.locations = [{
            name: '免费注册'
        }];
 
        //
        $scope.submit = function () {

            if ($scope.data.password != $scope.data.passwordT) {
                layer.msg('两次密码输入不一致，请重新输入', {icon: 5});
                return;
            }
            if ($scope.data.code != $scope.data.messageCode) {
                layer.msg('验证码输入不正确，请重新输入', {icon: 5, time: 1000});
                return;
            }
            if (/^[a-zA-Z]+$/.test($scope.data.password)) {
                layer.msg('密码不能全是字母，请重新输入', {icon: 5, time: 1000});
                return false;
            }
            if (/^[0-9]+$/.test($scope.data.password)) {
                layer.msg('密码不能全是数字，请重新输入', {icon: 5, time: 1000});
                return false;
            }
            if (!(/^1(3|4|5|7|8)\d{9}$/.test($scope.data.phone))) {
                layer.msg('请输入您的真实有效手机号', {icon: 5, time: 1000});
                return false;
            }
            var data = {
                userName: $scope.data.userName,
                password: $scope.data.password,
                userType: $scope.data.userType,
                phone: $scope.data.phone,
                email: $scope.data.email,
                forgot:$scope.data.code
            };
            userService.reg(data).then(function (data) {
                if (data.status == 0) {
                    if ($scope.data.userType == 'org') {
                        layerService.confirm('提示', '您注册的是机构会员，需要提交机构申请方可升级为机构管理员，是否立即去提交申请？', ['填写申请', '取消'], 'teal').then(function () {
                            window.location.href = config.trsHost + 'manage';
                        }, function () {
                            layer.msg('注册成功');
                            //$rootScope.$state.go('login');
                        });
                    } else {
                        layer.msg('注册成功');
                        //$rootScope.$state.go('login');
                    }
                } else {
                    layer.msg(data.statusDesc + '，请重新输入', {icon: 5});
                }
            })
        };

        $scope.reset = function () {

            layerService.confirm('提示', '确定要重填该表单吗？该操作将会清除已填信息。').then(function () {
                $scope.data.userName = '';
                $scope.data.password = '';
                $scope.data.passwordT = '';
                $scope.data.userType = 'user';
                $scope.data.phone = '';
                $scope.data.email = '';
                $scope.data.code = '';
            })
        }
    }
);

'use strict';

angular.module('app').controller('forgetController',
    function ($rootScope, $scope, tokenService, localStorageService, userService) {
        $scope.data = {};
        $scope.otherData = {};
        $scope.locations = [{
            name: '忘记密码'
        }];

        $scope.submit = function () {
            userService.setPwd({
                mobileId: $scope.data.mobileId,
                forgotString: $scope.data.forgotStrint,
                newPwd: $scope.data.newPwd
            }).then(function (data) {
                if (data.status === 0) {
                    layer.alert('密码修改成功', function (index) {
                        layer.close(index);
                        $rootScope.$state.go('login')
                    })
                } else {
                    layer.msg(data.statusDesc);
                }
            }, function () {
                layer.msg('未知原因导密码修改失败');
            });
        };
        $scope.reset = function () {
            $scope.data.userName = '';
        }
    }
);

'use strict';

angular.module('app').controller('loginController',
    function ($rootScope, $scope, tokenService, localStorageService, userService, config, venderService, cookiesService, communityService) {
        $scope.data = {};
        $scope.otherData = {};
        $scope.locations = [{
            name: '用户登录'
        }];
        $scope.submit = function () {
            if (!$scope.data.userName) {
                layer.msg('登录名称不能为空');
                return;
            }
            if (!$scope.data.userName) {
                layer.msg('登录名称不能为空');
                return;
            }
            tokenService.getToken($scope.data.userName, $scope.data.password).then(function (data) {
                var token = data.access_token;
                localStorageService.set('token', token);
                $rootScope.userInfo(true).then(function (data) {
                    if (data.result.userType == 'user') {
                        $rootScope.$state.go('user');
                    } else if (data.result.userType == 'org') {

                        cookiesService.set('kph-manage.token', '"' + token + '"');
                        cookiesService.set('kph-manage.platform', '"business"');
                        cookiesService.set('kph-manage.userId', '"' + data.result.userId + '"');
                        cookiesService.set('kph-manage.trueName', '"' + (data.result.trueName || '') + '"');
                        cookiesService.set('kph-manage.userAvatar', '"' + (data.result.userAvatar || '') + '"');

                        venderService.getInfo().then(function (data) {
                            localStorageService.clearAll();

                            cookiesService.set('kph-manage.venderStatus', '"' + (data.result ? data.result.venderStatus : '') + '"');
                            cookiesService.set('kph-manage.venderId', '"' + (data.result ? data.result.venderId : '') + '"');

                            if (data.result && data.result.venderStatus == 'active') {
                                window.location.href = config.trsHost + 'manage/business/info/detail'
                            } else {
                                window.location.href = config.trsHost + 'manage/business/home'
                            }
                        });

                    } else if (data.result.userType == 'community') {
                        communityService.getInfo().then(function (data) {
                            if (data.result && data.result.communityStatus == 'delete') {
                                layer.msg('登陆机构不存在，登陆失败！');
                            } else {
                                $rootScope.$state.go('user.auth');
                            }
                        });
                    }
                });
            }, function () {
                layer.msg('用户名或密码错误，请重新输入')
            })
        };
        $scope.reset = function () {
            $scope.data.userName = '';
            $scope.data.password = ''
        }
    }
);

'use strict';

angular.module('app').controller('noMatchController',
    function () {

    }
);

'use strict';

angular.module('app').controller('printController',
    function ($rootScope, $scope, initData) {
        $scope.data = initData.result;
        $scope.otherData = {};

        $scope.printPage = function () {
            window.print()
        }
    }
);

'use strict';

angular.module('app').controller('registerController',
    function ($rootScope, $scope, tokenService, localStorageService, userService, layerService, config) {
       
        $scope.data = {
            userType: 'user'
        };
        $scope.otherData = {};
        $scope.locations = [{
            name: '免费注册'
        }];
 
        //
        $scope.submit = function () {

            if ($scope.data.password != $scope.data.passwordT) {
                layer.msg('两次密码输入不一致，请重新输入', {icon: 5});
                return;
            }
            if ($scope.data.code != $scope.data.messageCode) {
                layer.msg('验证码输入不正确，请重新输入', {icon: 5, time: 1000});
                return;
            }
            if (/^[a-zA-Z]+$/.test($scope.data.password)) {
                layer.msg('密码不能全是字母，请重新输入', {icon: 5, time: 1000});
                return false;
            }
            if (/^[0-9]+$/.test($scope.data.password)) {
                layer.msg('密码不能全是数字，请重新输入', {icon: 5, time: 1000});
                return false;
            }
            if (!(/^1(3|4|5|7|8)\d{9}$/.test($scope.data.phone))) {
                layer.msg('请输入您的真实有效手机号', {icon: 5, time: 1000});
                return false;
            }
            var data = {
                userName: $scope.data.userName,
                password: $scope.data.password,
                userType: $scope.data.userType,
                phone: $scope.data.phone,
                email: $scope.data.email,
                forgot:$scope.data.code
            };
            userService.reg(data).then(function (data) {
                if (data.status == 0) {
                    if ($scope.data.userType == 'org') {
                        layerService.confirm('提示', '您注册的是机构会员，需要提交机构申请方可升级为机构管理员，是否立即去提交申请？', ['填写申请', '取消'], 'teal').then(function () {
                            window.location.href = config.trsHost + 'manage';
                        }, function () {
                            layer.msg('注册成功');
                            $rootScope.$state.go('login');
                        });
                    } else {
                        layer.msg('注册成功');
                        $rootScope.$state.go('login');
                    }
                } else {
                    layer.msg(data.statusDesc + '，请重新输入', {icon: 5});
                }
            })
        };

        $scope.reset = function () {

            layerService.confirm('提示', '确定要重填该表单吗？该操作将会清除已填信息。').then(function () {
                $scope.data.userName = '';
                $scope.data.password = '';
                $scope.data.passwordT = '';
                $scope.data.userType = 'user';
                $scope.data.phone = '';
                $scope.data.email = '';
                $scope.data.code = '';
            })
        }
    }
);

'use strict';

angular.module('app').controller('setPwdController',
    function ($rootScope, $scope, tokenService, localStorageService, userService) {
        $scope.data = {};
        $scope.otherData = {};
        $scope.locations = [{
            name: '设置密码'
        }];

        $scope.submit = function () {
            if ($scope.data.password != $scope.data.passwordT) {
                layer.msg('两次密码输入不一致，请重新输入', {icon: 5});
                return;
            }
            userService.setPwd($rootScope.$stateParams.code, $scope.data.password).then(function (data) {
                if (data.status == 0) {
                    $rootScope.$state.go('login');
                    layer.msg('密码重置成功');
                } else {
                    $rootScope.$state.go('forget');
                    layer.msg('链接已失效，请重新发送邮件');
                }
            }, function () {
                layer.msg('未知原因导致密码重置失败')
            })
        };

        $scope.reset = function () {
            $scope.data.password = '';
            $scope.data.passwordT = '';
        }
    }
);

'use strict';

angular.module('app').controller('userController',
    function ($rootScope, $scope, localStorageService) {
        $scope.data = {};
        $scope.otherData = {};
    }
);

'use strict';

angular.module('app').controller('venderController',
    function ($rootScope, $scope, localStorageService, venderService, $q) {
        $scope.data = {};
        $scope.otherData = {};
    }
);

'use strict';

angular.module('app').controller('yyController',
    function ($rootScope, $scope, localStorageService, $q) {
        $scope.data = {};
        $scope.otherData = {};
        $scope.active2 = true;
        $scope.user = "";
    }
);

'use strict';

angular.module('app').controller('activityDetailController',
    function ($rootScope, $scope, localStorageService, initData, $timeout, config) {
        $scope.data = initData[0].result;

        if ($scope.data.documentStatus != 'active' || !$scope.data) {
            window.location.href = config.trsHost;
        }

        $scope.otherData = {};

        if ($scope.data.documentAvatar) {
            $scope.data.documentAvatar = $scope.data.documentAvatar.split(',');
        }

        $scope.locations = [{
            name: '活动精选',
            value: 'activity'
        }];

        //地图坐标
        if ($scope.data.documentTag3) {
            $scope.data.documentTag3 = JSON.parse($scope.data.documentTag3);
            if ($scope.data.documentTag3.location && $scope.data.documentTag3.location.length > 0) {
                $timeout(function () {
                    var map = new BMap.Map("allmap", {enableMapClick: false});
                    var point = new BMap.Point($scope.data.documentTag3.location[0], $scope.data.documentTag3.location[1]);
                    map.centerAndZoom(point, 15);
                    map.enableScrollWheelZoom();
                    var marker = new BMap.Marker(point);
                    map.addOverlay(marker);
                }, 300)
            }
        }


        $timeout(function () {
            // jQuery(".preview").slide({
            //     titCell: ".smallImg li",
            //     mainCell: ".bigImg",
            //     effect: "fold",
            //     autoPlay: false,
            //     delayTime: 200
            // });
            // jQuery(".game163 .smallScroll").slide({
            //     mainCell: "ul",
            //     delayTime: 500,
            //     vis: 4,
            //     effect: "left",
            //     autoPage: false,
            //     prevCell: ".sPrev",
            //     nextCell: ".sNext",
            //     pnLoop: false
            // });

            
            // TouchSlide({ 
            //     slideCell:"#focus",
            //     titCell:".hd ul", //开启自动分页 autoPage:true ，此时设置 titCell 为导航元素包裹层
            //     mainCell:".bd ul", 
            //     effect:"left", 
            //     autoPlay:true,//自动播放
            //     autoPage:true, //自动分页
            //     switchLoad:"_src" //切换加载，真实图片路径为"_src" 
            // });

            window._bd_share_config = {
                "common": {
                    "bdSnsKey": {},
                    "bdText": "",
                    "bdMini": "2",
                    "bdPic": "",
                    "bdStyle": "0",
                    "bdSize": "24"
                },
                "share": {},
            };
            $('#activity-detail').append('<script type="text/javascript" src="http://bdimg.share.baidu.com/static/api/js/share.js?v=89860593.js?cdnversion=' + (-new Date() / 36e5) + '"></script>');
        }, 100);

    }
);

'use strict';

angular.module('app').controller('activityListController',
    function ($rootScope, $scope,$stateParams, localStorageService, activityService, relationService, initData, layerService, config, util) {
        $scope.otherData = {};
        $scope.locations = [{
            name: '活动精选'
        }];


        var search = util.deserialize($rootScope.$stateParams.search);
        if (search.month) {
            $scope.otherData.month = search.month;
        }else{
            $scope.otherData.month = "all";
        }
        
        $scope.change = function (value) {
            search.month = value;
            delete search.time;
            $rootScope.$state.go('activity.list', {
                search: util.serialize(search),
                pageNum: 1
            });
        };

        var prevItemYear = null;
        var prevItemMonthAndDay = null;
        $scope.totalPage = initData.totalPage;
        $scope.list = $.map(initData.result, function (item, index) {
            var year = item.documentStartTime.substring(0, 4);
            var monthAndDay = item.documentStartTime.substring(5, 10);
            item.month = item.documentStartTime.substring(5, 7);
            item.day = item.documentStartTime.substring(8, 10);
            if (!prevItemYear || prevItemYear != year) {
                item.year = year;
                prevItemYear = year;
            }
            if (!prevItemMonthAndDay || monthAndDay != prevItemMonthAndDay) {
                item.showMonthAndDay = true;
                prevItemMonthAndDay = monthAndDay;
            }
            return item;
        });

    }
);

'use strict';

angular.module('app').controller('userAuthController',
    function ($rootScope, $scope, localStorageService, initData, communityService, oprlogService) {
        $scope.data = initData.result || {};
        $scope.otherData = {
            open: false
        };

        oprlogService.getList(0, 1, {
            oprTargetType: 'community',
            oprTargetId: $scope.data.communityId
        }).then(function (data) {
            $scope.oprlogData = data.result[0];
        });

        if ($scope.data && $scope.data.phone) {
            $scope.data.phone = $scope.data.phone * 1;
        }

        $scope.locations = [{
            name: '个人中心',
            value: 'user'
        }, {
            name: '团体用户认证'
        }];


        /*$scope.switch = function () {
            $scope.otherData.open = true;
            $('.org').animate({
                height: 'auto'
            }, 2000)
        };*/

        $scope.submit = function () {
            if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test($scope.data.communityEmail)) {
                layer.msg('邮箱格式填写错误，请重新输入');
                return;
            }
            $scope.otherData.loading = true;
            var data = {
                communityName: $scope.data.communityName,
                communityDesc: $scope.data.communityDesc,
                communityAdmin: $scope.data.communityAdmin,
                communityEmail: $scope.data.communityEmail,
                communityPhone: $scope.data.communityPhone,
                communityAddr: $scope.data.communityAddr
            };

            if ($scope.data.communityId) {
                //修改社区信息
                data.communityId = $scope.data.communityId;
                communityService.update(data).then(function (data) {
                    if (data.status == 0) {
                        layer.msg('社区认证信息提交成功，请耐心等待管理员进行审核！');
                    } else {
                        layer.msg(data.statusDesc);
                    }
                    $rootScope.$state.reload();
                    $scope.otherData.loading = false;
                }, function () {
                    layer.msg('未知原因导致社区认证信息提交失败，请重试');
                    $scope.otherData.loading = false;
                })
            } else {
                //已添加社区信息
                communityService.add(data).then(function (data) {
                    if (data.status == 0) {
                        layer.msg('社区认证信息提交成功，请耐心等待管理员进行审核！');
                    } else {
                        layer.msg(data.statusDesc);
                    }
                    $rootScope.$state.reload();
                    $scope.otherData.loading = false;
                }, function () {
                    layer.msg('未知原因导致社区认证信息提交失败，请重试');
                    $scope.otherData.loading = false;
                })
            }

        }
    }
);

'use strict';

angular.module('app').controller('userListController',
    function ($rootScope, $scope, localStorageService, initData, relationService, layerService) {

        $scope.otherData = {};
        $scope.list = initData.result;
        $scope.totalPage = initData.totalPage;

        $scope.locations = [{
            name: '个人中心',
            value: 'user'
        }, {
            name: '我的预约'
        }];

        $scope.cancel = function (item) {
            layerService.confirm('提示', '确定要取消【' + item.documentTitle + '】活动的预约资格？', []).then(function () {
                relationService.del(item.relationId).then(function (data) {
                    if (data.status == 0) {
                        layer.msg('已成功取消预约', {icon: 1});
                        $rootScope.$state.reload();
                    } else {
                        alert(data.statusDesc);
                    }
                }, function () {
                    alert('未知原因倒是预约取消失败');
                })
            })
        }

    }
);

'use strict';

angular.module('app').controller('userInfoController',
    function ($rootScope, $scope, localStorageService, initData) {
        $scope.data = initData.result;

        $scope.otherData = {};

        $scope.locations = [{
            name: '个人中心',
            value: 'user'
        }, {
            name: '账户信息'
        }]
    }
);

'use strict';

angular.module('app').controller('userUpdateController',
    function ($rootScope, $scope, localStorageService, initData, userService) {
        $scope.data = initData.result;
        $scope.otherData = {};

        if ($scope.data.phone) {
            $scope.data.phone = $scope.data.phone * 1;
        }
        /*if ($scope.data.idCard) {
            $scope.otherData.canEditIdCard = true;
        }*/

        $scope.locations = [{
            name: '个人中心',
            value: 'user'
        }, {
            name: '完善信息'
        }];

        $scope.submit = function () {
            /*if (!/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/.test($scope.data.idCard)) {
                layer.msg('您输入的身份证格式错误，请重新输入');
                return;
            }*/
            $scope.otherData.loading = true;
            var data = {
                userAvatar: $scope.data.userAvatar,
                trueName: $scope.data.trueName,
                email: $scope.data.email,
                phone: $scope.data.phone
                //idCard: $scope.data.idCard
            };
            userService.update(data).then(function (data) {
                if (data.status == 0) {
                    $rootScope.$state.go('user.info');
                    layer.msg('信息修改成功');
                } else {
                    layer.msg(data.statusDesc);
                }
            }, function () {
                layer.msg('未知原因导致信息修改失败');
            })
        }

    }
);

'use strict';

angular.module('app').controller('userPwdController',
    function ($rootScope, $scope, localStorageService, userService) {
        $scope.data = {};
        $scope.otherData = {};

        $scope.locations = [{
            name: '个人中心',
            value: 'user'
        }, {
            name: '修改密码'
        }];


        $scope.submit = function () {
            if ($scope.data.password != $scope.data.passwordT) {
                layer.msg('两次密码输入不一致，请重新输入。');
                return;
            }
            userService.pwd({
                oldPwd: $scope.data.oldPwd,
                newPwd: $scope.data.password
            }).then(function (data) {
                if (data.status == 0) {
                    layer.msg('密码修改成功');
                    $rootScope.$state.reload();
                } else {
                    layer.msg(data.statusDesc);
                }
            }, function () {
                layer.msg('未知原因导致密码修改失败，请重试。');
            })
        };
        $scope.reset = function () {
            $scope.data.oldPwd = '';
            $scope.data.password = '';
            $scope.data.passwordT = '';
        }
    }
);

'use strict';

angular.module('app').controller('venderDetailController',
    function ($rootScope, $scope, localStorageService, initData, $timeout, activityService) {
        $scope.data = initData[0].result;
        $scope.otherData = {};

        if ($scope.data.venderAvatar) {
            $scope.data.venderAvatar = JSON.parse($scope.data.venderAvatar);
        }

        //跳转到列表
        if($scope.data.venderStatus != "active"){
            $rootScope.$state.go('vender.list');
        }

        $scope.list1 = [];
        $scope.pageNum1 = 1;
        $scope.getData1 = function (pageNum) {
            $scope.pageNum1 = pageNum;
            activityService.getList((pageNum - 1) * 6, 6, {
                documentVenderId: $scope.data.venderId,
                documentStatus: 'active',
                venderStatus: 'active',
                valid: false
            }).then(function (data) {
                $scope.list1 = data.result;
                $scope.pageTotal1 = data.totalPage;
            })
        };
        $scope.getData1(1);

        var map = null;
        $scope.bug = function () {
            if (!map) {
                if ($scope.data.venderMap) {
                    $scope.data.venderMap = JSON.parse($scope.data.venderMap);
                    if ($scope.data.venderMap && $scope.data.venderMap.length > 0) {
                        $timeout(function () {
                            map = new BMap.Map("allmap", {enableMapClick: false});
                            var point = new BMap.Point($scope.data.venderMap[0], $scope.data.venderMap[1]);
                            map.centerAndZoom(point, 14);
                            map.enableScrollWheelZoom();
                            var marker = new BMap.Marker(point);
                            map.addOverlay(marker);
                        }, 300)
                    }
                }
            }
        };


        $scope.list2 = [];
        $scope.pageNum2 = 1;
        $scope.getData2 = function (pageNum) {
            $scope.pageNum2 = pageNum;
            activityService.getList((pageNum - 1) * 10, 10, {
                documentVenderId: $scope.data.venderId,
                documentStatus: 'active',
                venderStatus: 'active',
                valid: true
            }).then(function (data) {
                $scope.list2 = data.result;
                $scope.pageTotal2 = data.totalPage;
            })
        };
        $scope.getData2(1);


        $scope.list3 = [];
        $scope.pageNum3 = 1;
        $scope.getData3 = function (pageNum) {
            $scope.pageNum3 = pageNum;
            activityService.getList((pageNum - 1) * 10, 10, {
                documentVenderId: $scope.data.venderId,
                documentStatus: 'active',
                venderStatus: 'active',
                documentTag2: '21'
            }).then(function (data) {
                $scope.list3 = data.result;
                $scope.pageTotal3 = data.totalPage;
            })
        };
        $scope.getData3(1);


        // $timeout(function () {
        //     $(".superSlide").slide({mainCell: ".preview", effect: "leftLoop", autoPlay: true});
        // }, 300);

        $scope.locations = [{
            name: '科普市集',
            value: 'vender'
        }]
    }
);

'use strict';

angular.module('app').controller('venderListController',
    function ($rootScope, $scope, localStorageService, initData) {
        $scope.recommendList = initData[0].result;
        $scope.list = initData[1].result;
        $scope.totalPage = initData[1].totalPage;
        $scope.otherData = {};

        $scope.getVenderFirstAvatar = function (venderAvatar) {
            if (!venderAvatar) {
                return 'assets/images/vender-default.jpg';
            }
            var avatar = JSON.parse(venderAvatar);
            if (avatar.constructor == Array && avatar.length > 0) {
                return avatar[0].img
            } else {
                return 'assets/images/vender-default.jpg';
            }
        };

        $scope.locations = [{
            name: '科普集市'
        }];
    }
);

'use strict';

angular.module('app').controller('venderSearchController',
    function ($rootScope, $scope, localStorageService, initData) {
        $scope.list = initData.result;
        $scope.totalPage = initData.totalPage;
        $scope.otherData = {};

        $scope.getVenderFirstAvatar = function (venderAvatar) {
            if (!venderAvatar) {
                return 'assets/images/vender-default.jpg';
            }
            var avatar = JSON.parse(venderAvatar);
            if (avatar.constructor == Array && avatar.length > 0) {
                return avatar[0].img
            } else {
                return 'assets/images/vender-default.jpg';
            }
        };

        $scope.locations = [{
            name: '科普集市',
            value: 'vender'
        }];
    }
);

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/directives/banner/banner.html","<div id=banner class=banner><img ng-src={{img}}></div>");
$templateCache.put("app/directives/activityAside/activityAside.html","<div class=activityAside><h2>活动条件查询</h2><div class=search><div class=item style=\"z-index: 10\"><label>活动分类：</label><div custom-select=\"\" options=activityCategoryList ng-model=search.acC change=change()></div></div><!-- <div class=\"item\" style=\"z-index: 9\">\r\n            <label>活动状态：</label>\r\n            <div custom-select=\"\" options=\"activityValidList\" ng-model=\"search.acV\"\r\n                 change=\"change()\"></div>\r\n        </div>--><div class=item style=\"z-index: 8\"><label>店铺类型：</label><div custom-select=\"\" options=venderTypeList ng-model=search.veT change=change()></div></div><div class=item style=\"z-index: 7\"><label>活动类型：</label><div custom-select=\"\" options=activityTypeList ng-model=search.acT change=change()></div></div><div class=item style=\"z-index: 6\"><label>活动地域：</label><div custom-select=\"\" options=activityTagList ng-model=search.acTa change=change()></div></div><a href=javascript:; ng-click=submit() class=searchBtn></a></div><h2>活动日期查询</h2><div calendar=\"\" events=eventList current=currentDate></div></div>");
$templateCache.put("app/directives/calendar/calendar.html","<div id=activity-calendar style=\"width: 200px\"></div>");
$templateCache.put("app/directives/columnLocation/columnLocation.html","<div id=columnLocation class=columnLocation>当前位置：<a ng-href=\"{{getTrsUrl(\'\')}}\">首页</a> <span ng-repeat=\"item in locations\">>> <a ui-sref={{item.value}} ng-if=item.value ng-bind=item.name></a> <span ng-if=!item.value ng-bind=item.name></span></span></div>");
$templateCache.put("app/directives/columnTitleBar/columnTitleBar.html","<div id=columnTitleBar class=columnTitleBar ng-style=style><div column-location=locations></div></div>");
$templateCache.put("app/directives/customSelect/customSelect.html","<div class=customSelect><div class=current ng-click=open($event)><div class=text ng-bind=current.name></div><a class=icon></a></div><div class=list><div class=item ng-repeat=\"item in list\" ng-class=\"{active:item.value==value}\" ng-click=checked(item,$event) ng-bind=item.name></div></div></div>");
$templateCache.put("app/directives/imgCode/imgCode.html","<div class=imgCode><img ng-src={{curentCode.img}} ng-click=clickHandler() title=点击切换></div>");
$templateCache.put("app/directives/messageCode/messageCode.html","<div class=messageCode><button class=\"ui teal button\" ng-class={disabled:otherData.waiting} ng-click=clickHandler()><span ng-if=!otherData.waiting>获取短信验证码</span> <span ng-if=otherData.waiting><span ng-bind=otherData.date></span> 秒后可重新获取</span></button></div><div class=layer_notice style=\"display: none;width: 300px;height:200px;padding-top:20px\"><div style=\"text-align: center\"><!-- <img src=\'assets/images/getCode0.png\' style=\'width:60%;height:40px;\' /> --> <img ng-click=change() ng-src=\"http://kph.tjkp.org.cn/public/user/cha?timestamp={{random}}\" style=width:80%;height:60px></div><div style=\"text-align: left;line-height: 4rem;padding-left:2rem;margin-bottom: 20px\">验证码：<input type=text ng-model=verifyCode style=\"line-height: 2rem;width:150px;margin-left: 15px\"></div><div style=\"text-align: center\"><input type=button ng-click=getImgCode() style=\"height: 2rem;width:80%\" value=确定></div></div>");
$templateCache.put("app/directives/pageFooter/pageFooter.html","<div id=FooterBox><div id=footer><div class=block><ul><li style=\"font-weight: bold\">友情链接</li><li><a  >中国环保科普资源网</a></li><li><a >天津青少年科技创新活动服务平台</a></li><li><a  >《天津科技》杂志</a></li></ul></div><div class=block2><ul><li style=\"font-weight: bold\">关于我们</li><li><a href=http://kph.tjkp.org.cn/gywm/201705/t20170527_129618.html>科普惠简介</a></li><li><a href=http://kph.tjkp.org.cn/flsm/201706/t20170620_130111.html>法律声明</a></li><li><a href=http://kph.tjkp.org.cn/bqsm/201706/t20170620_130114.html>版权声明</a></li></ul></div><div class=block1><ul><li style=\"font-weight: bold\">联系方式</li><li>电话：022-23330583</li><li>邮箱：tjkp@tjkp.org.cn</li></ul></div><div class=block3><div class=pic></div><p>科普惠</p></div><p>版权所有&nbsp;&nbsp;天津市科学技术信息研究所&nbsp;&nbsp;All Rights Reserved</p><p>津ICP备05001152号</p></div></div>");
$templateCache.put("app/directives/pageHeader/pageHeader.html","<div id=pageHeader class=pageHeader><div class=wrapper><a class=logo ng-href=\"{{getTrsUrl(\'\')}}\"></a><div class=topBar><div class=floatNav><span ng-if=!userId><a ui-sref=login>用户登录</a><span>|</span> <a ui-sref=register>免费注册</a><span>|</span> </span><span ng-if=userId>【<a href=javascript:; ng-click=goUserPage() class=user ng-bind=userName></a>】 <a ng-click=exit() href=javascript:; style=\"padding-left: 0\">退出</a><span>|</span> </span><a href=http://kph.tjkp.org.cn/bzzx/ >帮助中心</a>| <a href=http://kph.tjkp.org.cn/gywm/201705/t20170527_129618.html>关于我们</a></div><div class=search><form class=form name=form novalidate ng-submit=submit()><div class=select><div class=current><span>活动</span> <i></i></div><div class=list><div class=\"item item1\" data-value=0><i></i> 活动</div><div class=\"item item2\" data-value=1><i></i> 店铺</div><div class=\"item item3\" data-value=2><i></i> 资源</div></div></div><input class=searchText type=text ng-model=search.acN placeholder=搜索关键字> <input class=searchBtn type=submit></form></div></div><div class=nav><ul><li><a ng-href=\"{{getTrsUrl(\'\')}}\">首　页</a></li><li ng-class=\"{active:name.indexOf(\'vender\')>-1}\"><a class=down ui-sref=vender>科普市集</a><ul><li ng-class=\"{active:search.acC*1==2}\"><a ui-sref=vender.list({pageNum:1,venderType:1})>科普场馆</a></li><li ng-class=\"{active:search.acC*1==3}\"><a ui-sref=vender.list({pageNum:1,venderType:2})>主题公园</a></li><li ng-class=\"{active:search.acC*1==4}\"><a ui-sref=vender.list({pageNum:1,venderType:3})>青少年科普活动站</a></li><li ng-class=\"{active:search.acC*1==5}\"><a ui-sref=vender.list({pageNum:1,venderType:4})>机构开放</a></li><li ng-class=\"{active:search.acC*1==1}\"><a ui-sref=vender.list({pageNum:1,venderType:5})>加盟店铺</a></li></ul></li><li ng-class=\"{active:name.indexOf(\'activity\')>-1}\"><a class=down ui-sref=activity>活动精选</a><ul><li ng-class=\"{active:search.acC*1==2}\"><a href=javascript:; ng-click=goActivityList(2)>公园展馆</a></li><li ng-class=\"{active:search.acC*1==3}\"><a href=javascript:; ng-click=goActivityList(3)>观光农业</a></li><li ng-class=\"{active:search.acC*1==4}\"><a href=javascript:; ng-click=goActivityList(4)>创新探索</a></li><li ng-class=\"{active:search.acC*1==5}\"><a href=javascript:; ng-click=goActivityList(5)>健康养生</a></li><li ng-class=\"{active:search.acC*1==1}\"><a href=javascript:; ng-click=goActivityList(1)>益智成长</a></li><li ng-class=\"{active:search.acC*1==6}\"><a href=javascript:; ng-click=goActivityList(6)>优惠专区</a></li></ul></li><li><a class=down ng-href=\"{{getTrsUrl(\'hwgl/\')}}\">惠玩攻略</a><ul><li><a ng-href=\"{{getTrsUrl(\'hwgl/hgl/\')}}\">惠攻略</a></li><li><a ng-href=\"{{getTrsUrl(\'hwgl/wgl/\')}}\">玩攻略</a></li></ul></li><li><a ng-href=\"{{getTrsUrl(\'cxty/\')}}\">创新体验</a></li><li><a ng-href=\"{{getTrsUrl(\'cggs/\')}}\">场馆故事</a></li><li><a ng-href=\"{{getTrsUrl(\'kpts\')}}\">科普图书</a></li></ul></div></div></div>");
$templateCache.put("app/directives/tabs/tabs.html","<div class=tabs><div class=\"ui top attached tabular menu\"><div class=\"item item{{$index}}\" ng-repeat=\"tab in tabsCtrl.tabs\" ng-click=tabsCtrl.select(tab) ng-class={active:tab.active} ng-bind=tab.title></div></div><div ng-transclude=\"\"></div></div>");
$templateCache.put("app/directives/pagination/pagination.html","<div class=\"ui teal pagination menu\"><a class=\"icon item\" ng-click=changePage(1) ng-class=\"{disabled:pageCurrent==1}\">首页 </a><a class=\"icon item\" ng-click=prevPage() ng-class=\"{disabled:pageCurrent==1}\">&lt;&lt;上一页 </a><a class=item ng-repeat=\"item in pageList track by $index\" ng-click=changePage(item) ng-class=\"{active:item==pageCurrent}\" ng-bind=item></a> <a class=\"icon item\" ng-click=nextPage() ng-class=\"{disabled:pageCurrent==pageTotal}\">下一页&gt;&gt; </a><a class=\"icon item\" ng-click=changePage(pageTotal) ng-class=\"{disabled:pageCurrent==pageTotal}\">尾页</a></div>");
$templateCache.put("app/directives/upload/upload.html","<!--\r\n\r\n###指令扩展基础结构\r\n\r\n<div class=\"upload multiple\">\r\n  ###顶部备注\r\n  <p class=\"annotation\">\r\n    <span class=\"orange\">注</span>：详情图为必填选项\r\n  </p>\r\n\r\n  ###主题上传部分\r\n  <div class=\"body\">\r\n    ###上传按钮(必须含有)\r\n    <div class=\"uploadBtn img-empty\">\r\n      <i class=\"iconfont icon-add\"></i>\r\n    </div>\r\n  </div>\r\n\r\n  ###错误备注\r\n  <p class=\"error\" ng-if=\"errorInfo\"><i class=\"iconfont icon-error\"></i> {{errorInfo}}</p>\r\n</div>\r\n-->");
$templateCache.put("app/directives/userAvatar/userAvatar.html","<div class=userSelectAvatar><p class=annotation><span class=orange>注</span>： <span ng-transclude=\"\"></span></p><ul><li ng-repeat=\"item in avatars\" ng-class=\"{active:item==current}\" ng-click=selected(item)><img ng-src={{item}}></li></ul></div>");
$templateCache.put("app/directives/userNav/userNav.html","<div id=userNav class=userNav><ul><li ng-class=\"{active:name.indexOf(\'user.auth\')>-1}\" ng-if=\"userType==\'community\'\"><a ui-sref=user.auth>团体用户认证</a></li><li ng-class=\"{active:name.indexOf(\'user.info\')>-1}\"><a ui-sref=user.info>账户信息</a></li><li ng-class=\"{active:name.indexOf(\'user.update\')>-1}\"><a ui-sref=user.update>完善信息</a></li><li ng-class=\"{active:name.indexOf(\'user.list\')>-1}\"><a ui-sref=user.list>我的预约</a></li><li ng-class=\"{active:name.indexOf(\'user.pwd\')>-1}\"><a ui-sref=user.pwd>修改密码</a></li></ul></div>");
$templateCache.put("app/module/activity/activity.html","<div id=activity ui-view></div>");
$templateCache.put("app/module/forget/forget.html","<div id=forget><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-forget.png locations=locations></div><div class=columnContent><form class=form name=form novalidate><div class=field><label>手机号码：</label><input class=input type=text placeholder=必填项，请输入您的手机号码 name=mobileId ng-model=data.mobileId required></div><div class=field><label>验证码：</label><input class=input type=text placeholder=必填项，请输入验证码 name=forgotStrintss ng-model=data.forgotStrint required style=\"width: 160px\"><div message-code=\"\" mobile-id=data.mobileId type=password ng-model=data.messageCode></div></div><div class=field><label>新密码：</label><input class=input type=password placeholder=必填项，请输入您的新密码 name=newPwd ng-model=data.newPwd required></div><div class=buttons><button class=\"submit ui button\" ng-class={disabled:form.$invalid} onclick=\"return false\" ng-disabled=form.$invalid ng-click=submit()>确定</button> <button class=\"reset ui button\" onclick=\"return false\" ng-click=reset()>重填</button></div></form></div></div></div>");
$templateCache.put("app/module/kptj/kptj.html","<div id=register><div class=wrapper><div banner=\"\'assets/images/banner_kptj.jpg\'\"></div><div column-title-bar=assets/images/columnTitleBar-register.png locations=locations></div><div class=columnContent><div class=tip>说明：带 <span>*</span> 部分为必填项。未认证会员，不能参加与网站相关的会员活动。</div><form class=form name=form novalidate><div class=field><label><span>*</span>会员类型：</label><select ng-model=data.userType><option value=user>个人会员（适合个人用户注册，可预约科普产品）</option><!-- <option value=\"community\">团体会员（适合街道办、社区居委会、学校等有科普需求的单位注册，可批量预约科普产品）</option>\r\n                        <option value=\"org\">机构会员（适合科普基地等机构注册，可建立店铺并发布科普产品）</option> --></select></div><div class=field><label><span>*</span>登录名称：<span>（本单位名称中文全称）</span></label><input class=input type=text placeholder=必填项，请输入登录名称 name=userName ng-model=data.userName required></div><div class=field><label><span>*</span>登录密码：<span>（密码中请包含字母、数字或特殊字符）</span></label><input class=input type=password placeholder=必填项，请输入登录密码 name=password ng-model=data.password required></div><div class=field><label><span>*</span>确认密码：</label><input class=input type=password placeholder=必填项，请再次输入登录密码 name=passwordT ng-model=data.passwordT required></div><div class=field><label><span>*</span>手机号码：<span>（统计账号填报联系人手机号）</span></label><input class=input type=text placeholder=必填项，请输入手机号码 name=phone ng-model=data.phone required></div><div class=field><label><span>*</span>电子邮箱：<span>（请填写您的常用邮箱）</span></label><input class=input type=text placeholder=必填项，请输入电子邮箱 name=email ng-model=data.email required></div><div class=field><label><span>*</span>验证码：</label><input class=input type=text placeholder=必填项，请输入验证码 name=code style=\"width: 260px\" ng-model=data.code required><div message-code=\"\" is-reg=1 mobile-id=data.phone ng-model=data.messageCode></div></div><div class=\"field checkboxField\"><input type=checkbox class=checkbox name=code ng-model=data.can required> 已阅读并同意<a target=_blank href=http://kph.tjkp.org.cn/fwxy/201706/t20170622_130174.html><span>服务协议</span></a></div><div class=buttons><button class=\"reset ui button\" onclick=\"return false\" ng-click=reset()>重填</button> <button class=\"submit ui button\" onclick=\"return false\" ng-class={disabled:form.$invalid} ng-disabled=form.$invalid ng-click=submit()>注 册</button></div></form></div></div></div>");
$templateCache.put("app/module/login/login.html","<div id=login><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-login.png locations=locations></div><div class=columnContent><form class=form name=form novalidate><div class=field><label>登录名称：</label><input class=input type=text placeholder=必填项，请输入登录名称 name=userName ng-model=data.userName></div><div class=field><label>登录密码：</label><input class=input type=password placeholder=必填项，请输入登录密码 name=password ng-model=data.password></div><div class=\"field forget\"><a ui-sref=register>还未注册？</a> <a ui-sref=forget>忘记密码？</a></div><div class=buttons><button class=\"submit ui button\" onclick=\"return false\" ng-disabled=form.$invalid ng-click=submit()>登录</button> <button class=\"reset ui button\" onclick=\"return false\" ng-click=reset()>重填</button></div></form></div></div></div>");
$templateCache.put("app/module/noMatch/noMatch.html","<div id=noMatch><img src=assets/images/error.png><h1>您访问的地址不存在</h1></div>");
$templateCache.put("app/module/setPwd/setPwd.html","<div id=setPwd><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-forget.png locations=locations></div><div class=columnContent><form class=form name=form novalidate><div class=field><label><span>*</span>新的密码：</label><input class=input type=password placeholder=必填项，请输入登陆密码 name=password ng-model=data.password required></div><div class=field><label><span>*</span>确认密码：</label><input class=input type=password placeholder=必填项，请再次输入登陆密码 name=passwordT ng-model=data.passwordT required></div><div class=buttons><button class=\"submit ui button\" ng-class={disabled:form.$invalid} onclick=\"return false\" ng-disabled=form.$invalid ng-click=submit()>修改</button> <button class=\"reset ui button\" onclick=\"return false\" ng-click=reset()>重填</button></div></form></div></div></div>");
$templateCache.put("app/module/print/print.html","<div id=print><div class=content><table class=\"ui celled table\" cellspacing=0 cellpadding=0><thead><tr><th colspan=4>预约信息</th></tr></thead><tbody><tr><td class=\"bold right aligned\">活动标题：</td><td colspan=3>{{data.documentTitle}}</td></tr><tr><td class=\"bold right aligned\">活动时间：</td><td style=\"width: 260px\">{{getActivityTime(data.documentStartTime,data.documentEndTime)}}</td><td class=\"bold right aligned\">预约数量：</td><td>{{data.orderNum}}</td></tr><tr></tr><tr ng-if=data.documentOrderLimit><td class=\"bold right aligned\">预约要求：</td><td colspan=3>{{data.documentOrderLimit}}</td></tr><tr><td class=\"bold right aligned\">活动地址：</td><td colspan=3>{{data.documentAddr}}</td></tr></tbody></table><div class=tip><p>* 若打印时不需要页眉和页脚，可在打印选项中取消页眉页脚。</p><p>* 若打印失败可尝试使用chrome浏览器或者双核浏览器极速模式进行打印。</p></div><div class=btns><a class=\"ui tiny compact teal button\" ng-click=printPage()><i class=\"icon print\"></i> 打印</a></div></div></div>");
$templateCache.put("app/module/register/register.html","<div id=register><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-register.png locations=locations></div><div class=columnContent><div class=tip>说明：带 <span>*</span> 部分为必填项。未认证会员，不能参加与网站相关的会员活动。</div><form class=form name=form novalidate><div class=field><label><span>*</span>会员类型：</label><select ng-model=data.userType><option value=user>个人会员（适合个人用户注册，可预约科普产品）</option><option value=community>团体会员（适合街道办、社区居委会、学校等有科普需求的单位注册，可批量预约科普产品）</option><option value=org>机构会员（适合科普基地等机构注册，可建立店铺并发布科普产品）</option></select></div><div class=field><label><span>*</span>登录名称：</label><input class=input type=text placeholder=必填项，请输入登录名称 name=userName ng-model=data.userName required></div><div class=field><label><span>*</span>登录密码：<span>(密码中请包含字母、数字或特殊字符)</span></label><input class=input type=password placeholder=必填项，请输入登录密码 name=password ng-model=data.password required></div><div class=field><label><span>*</span>确认密码：</label><input class=input type=password placeholder=必填项，请再次输入登录密码 name=passwordT ng-model=data.passwordT required></div><div class=field><label><span>*</span>手机号码：<span>（请务必留下您的有效手机号，以免影响平台注册和使用）</span></label><input class=input type=text placeholder=必填项，请输入手机号码 name=phone ng-model=data.phone required></div><div class=field><label><span>*</span>电子邮箱：<span>（请填写您的常用邮箱）</span></label><input class=input type=text placeholder=必填项，请输入电子邮箱 name=email ng-model=data.email required></div><div class=field><label><span>*</span>验证码：</label><input class=input type=text placeholder=必填项，请输入验证码 name=code style=\"width: 260px\" ng-model=data.code required><div message-code=\"\" is-reg=1 mobile-id=data.phone ng-model=data.messageCode></div></div><div class=\"field checkboxField\"><input type=checkbox class=checkbox name=code ng-model=data.can required> 已阅读并同意<a target=_blank href=http://kph.tjkp.org.cn/fwxy/201706/t20170622_130174.html><span>服务协议</span></a></div><div class=buttons><button class=\"reset ui button\" onclick=\"return false\" ng-click=reset()>重填</button> <button class=\"submit ui button\" onclick=\"return false\" ng-class={disabled:form.$invalid} ng-disabled=form.$invalid ng-click=submit()>注 册</button></div></form></div></div></div>");
$templateCache.put("app/module/user/user.html","<div id=user ui-view></div>");
$templateCache.put("app/module/vender/vender.html","<div id=vender ui-view></div>");
$templateCache.put("app/module/yy/yy.html","<form name=myForm novalidate><p>用户名:<br><input type=text name=user ng-model=user required> <span style=color:red ng-show=\"myForm.user.$dirty && myForm.user.$invalid\"><span ng-show=myForm.user.$error.required>用户名是必须的。</span></span></p><p><input type=submit ng-disabled=\"myForm.user.$dirty || myForm.user.$invalid\"></p></form><div ng-class=\"{\'active1 active3\':active2}\">1234</div><div id=yy ui-view></div>");
$templateCache.put("app/directives/tabs/tab/tab.html","<div class=\"ui bottom attached tab segment\" ng-class={active:active}><div ng-transclude=\"\"></div></div>");
$templateCache.put("app/directives/upload/single/single.html","<div class=\"upload single\"><!--顶部备注--><p class=annotation><span class=orange>注</span>： <span ng-transclude=\"\"></span></p><!--多图上传--><div class=body><div class=img-box ng-style=sizeStyle ng-class=\"{\'ui loading\':uploading}\"><div class=img-empty ng-if=!imgs[imgs.length-1]><i class=\"iconfont icon-upload\"></i></div><img ng-src={{imgs[imgs.length-1]}} ng-if=\"imgs.length>0\"></div><!--上传按钮--><div class=img-cont ng-class={uploading:uploading}><div class=subAnnotation><span ng-if=width&&height>尺寸为<span ng-bind=width></span>*<span ng-bind=height></span>像素，</span> <span ng-if=width&&!height>尺寸为宽度<span ng-bind=width></span>像素</span> <span ng-if=!width&&height>尺寸为高度<span ng-bind=height></span>像素</span> <span>格式为<span ng-bind=\"type.join(\'、\')\"></span>，图片大小不可大于<span ng-bind=size></span>M。</span></div><div class=uploadBtn><span ng-if=!uploading>{{imgs[0]?\'重新上传\':\'开始上传\'}}</span> <span ng-if=uploading>正在上传：<span ng-bind=uploadProgress></span>%</span></div></div></div><!--错误备注--><p class=error ng-if=errorInfo><i class=\"iconfont icon-error\"></i> <span ng-bind=errorInfo></span></p></div>");
$templateCache.put("app/directives/upload/multiple/multiple.html","<div class=\"upload multiple\"><!--顶部备注--><p class=annotation><span class=orange>注</span>： <span ng-transclude=\"\"></span> <span ng-if=width&&height>尺寸为<span ng-bind=width></span>*<span ng-bind=height></span>像素，</span> <span ng-if=width&&!height>尺寸为宽度<span ng-bind=width></span>像素</span> <span ng-if=!width&&height>尺寸为高度<span ng-bind=height></span>像素</span> <span>格式为<span ng-bind=\"type.join(\'、\')\"></span>，图片大小不可大于<span ng-bind=size></span>M。</span></p><div class=body ui-sortable=sortableOptions ng-model=imgs><!--多图上传--><div class=img-box ng-repeat=\"img in imgs\" ng-style=sizeStyle><img class=view-img ng-src={{img}}> <i class=del-img tooltips tooltip-template=删除已传图片 tooltip-class=red ng-click=delImg($index)>X</i></div><!--上传按钮--><div class=img-cont style=\"display: block\" ng-style=sizeStyle ng-show=\"imgs.length<max\" ng-class=\"{\'ui loading\':uploading}\"><div class=\"uploadBtn img-empty\"><i class=\"iconfont icon-add\"></i></div></div></div><!--错误备注--><p class=error ng-if=errorInfo><i class=\"iconfont icon-error\"></i> <span ng-bind=errorInfo></span></p></div>");
$templateCache.put("app/module/activity/detail/detail.html","<div id=activity-detail><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-activity.png locations=locations></div><div class=columnContent><div class=leftBlock><!-- 图片预览 --><!--                  <div class=\"preview\">\r\n                    <ul class=\"bigImg\">\r\n                        <li ng-repeat=\"item in data.documentAvatar\">\r\n                            <img ng-src=\"{{item}}\">\r\n                        </li>\r\n                    </ul>\r\n                    <div class=\"smallScroll\">\r\n                        <a class=\"sPrev prevStop\" href=\"javascript:void(0)\">←</a>\r\n                        <a class=\"sNext\" href=\"javascript:void(0)\">→</a>\r\n                        <div class=\"smallImg\">\r\n                            <ul>\r\n                                <li ng-repeat=\"item in data.documentAvatar\">\r\n                                    <img ng-src=\"{{item}}\">\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n                    </div>\r\n                </div>  --><div id=focus class=focus><!-- <div class=\"hd\">\r\n                        <ul></ul>\r\n                    </div>\r\n                    <div class=\"bd\">\r\n                        <ul>\r\n                            <li ng-repeat=\"item in data.documentAvatar\">\r\n                                    <img ng-src=\"{{item}}\">\r\n                            </li>\r\n                        </ul>\r\n                    </div> --> <img style=\"width:370px;  height:335px\" ng-src={{data.documentAvatar[0]}}></div><!-- 活动信息 --><div class=info><div class=title ng-bind=data.documentTitle></div><div class=desc><p ng-if=\"data.documentTag2!=21\"><label>活动时间：</label><span ng-bind=getActivityTime(data.documentStartTime,data.documentEndTime)></span></p><p ng-if=\"data.documentTag2==21\"><label>活动时间：</label><span>常年开放</span></p><p><label>主/承办单位：</label><span ng-bind=data.documentOrganizer></span></p><p><label>活动地址：</label><span ng-bind=data.documentAddr></span></p><p ng-if=data.documentSpeaker><label>主讲人：</label><span ng-bind=data.documentSpeaker></span></p><p><label>咨询电话：</label><span ng-bind=data.documentMobileid></span></p><p><label>活动类型：</label><span ng-bind=getActivityTypeName(data.documentType)></span></p></div><div class=other ng-if=\"data.documentTag2!=21\"><div class=tag1><span ng-if=compareWithNow(data.documentEntryStartTime,data.documentEntryEndTime) ng-bind=data.documentTotalNum-data.documentRemainNum></span> <span ng-if=!compareWithNow(data.documentEntryStartTime,data.documentEntryEndTime) ng-bind=data.documentTotalNum></span> /<span ng-bind=data.documentTotalNum></span></div><div class=tag2></div><a ng-if=compareWithNow(data.documentEntryStartTime,data.documentEntryEndTime) class=reserve ng-click=reserve(data) ng-class=\"{can:data.documentRemainNum!=0}\"></a><div ng-if=!compareWithNow(data.documentEntryStartTime,data.documentEntryEndTime) class=tag3></div></div></div><div class=description><div class=condition ng-if=data.documentOrderLimit||data.documentParticipation><div ng-if=data.documentOrderLimit><h2>预约条件：</h2><i></i><p ng-bind=data.documentOrderLimit style=\"margin-bottom: 20px\"></p></div><div ng-if=data.documentOrderLimit class=division></div><div ng-if=data.documentParticipation><h2>参与方式：</h2><i></i><p ng-bind=data.documentParticipation style=\"margin-bottom: 20px\"></p></div><div ng-if=data.documentParticipation class=division></div><div ng-if=data.documentTag3.discount><h2>店铺优惠：</h2><i></i><p ng-bind=data.documentTag3.discount style=\"margin-bottom: 20px\"></p></div></div><div class=content><h2>活动详情：</h2><div ng-bind-html=safeHtml(data.documentContent)></div><a ng-if=data.documentTag3.attach ng-href={{data.documentTag3.attach}} target=_blank style=\"color: #2f7bc6;text-decoration: underline\">点击下载资源</a></div><div class=share style=\"text-align: right;padding-top: 30px\"><div class=bdsharebuttonbox style=\"display: inline-block\"><a href=# class=bds_more data-cmd=more></a> <a href=# class=bds_qzone data-cmd=qzone></a> <a href=# class=bds_tsina data-cmd=tsina></a> <a href=# class=bds_tqq data-cmd=tqq></a> <a href=# class=bds_renren data-cmd=renren></a> <a href=# class=bds_weixin data-cmd=weixin></a></div></div></div></div><div class=aside><div class=traffic ng-if=data.documentTag3.bus||data.documentTag3.metro><h2>交通路线</h2><div class=bus ng-if=data.documentTag3.bus><i></i> <span ng-bind=data.documentTag3.bus></span></div><div class=metro ng-if=data.documentTag3.metro><i></i> <span ng-bind=data.documentTag3.metro></span></div><div class=parking ng-if=data.documentTag3.parking><i></i> <span ng-bind=data.documentTag3.parking></span></div></div><div class=map ng-if=data.documentTag3.location><h2>地图坐标</h2><div id=allmap ng-if=\"data.documentTag3.location.length>0\"></div></div></div></div></div></div>");
$templateCache.put("app/module/activity/list/list.html","<div id=activity-list><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-activity.png locations=locations></div><div class=columnContent><div class=subNav><a href=javascript:; ng-class=\"{active:otherData.month==\'all\'}\" ng-click=\"change(\'all\')\">所有活动</a> <a href=javascript:; ng-class=\"{active:otherData.month==\'current\'}\" ng-click=\"change(\'current\')\">当月活动</a> <a href=javascript:; ng-class=\"{active:otherData.month==\'next\'}\" ng-click=\"change(\'next\')\">下月活动</a> <a href=javascript:; ng-class=\"{active:otherData.month==\'history\'}\" ng-click=\"change(\'history\')\">历史活动</a></div><div class=activityList><ul class=list><li ng-repeat=\"item in list\" class=item><div class=year ng-if=item.year><span ng-bind=item.year></span></div><div class=monthAndDay ng-if=item.showMonthAndDay><div class=month><span ng-bind=item.month></span>月</div><div class=day ng-bind=item.day></div></div><div class=preview><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情><img ng-src={{item.documentAvatar|indexImg:0}}></a></div><div class=info><div class=title><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情 ng-bind=item.documentTitle></a></div><div class=other><p>时 间：<span ng-bind=getActivityTime(item.documentStartTime,item.documentEndTime)></span></p><p>主/承办单位：<span ng-bind=item.documentOrganizer></span></p><p>活动类型：<span ng-bind=getActivityTypeName(item.documentType)></span></p><p>总预约人数： <span ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)><span ng-bind=item.documentTotalNum></span> / 仍可预约<span ng-bind=item.documentRemainNum></span>人 </span><span ng-if=!compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)>已结束</span></p></div></div><a ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime) class=reserve ng-click=reserve(item) ng-class=\"{can:item.documentRemainNum!=0}\"></a></li></ul><div pagination=\"\" page-total=totalPage ng-if=\"list.length>0\"></div><div ng-if=\"list.length==0\" class=nothing>没有符合条件的记录</div></div><div activity-aside=eventList></div></div></div></div>");
$templateCache.put("app/module/user/auth/auth.html","<div id=user-auth><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-user.png locations=locations></div><div user-nav=user.auth></div><div class=columnContent><div class=content><div class=\"ui message\" ng-if=!data.communityId>您还没提交用户信息，请填写。</div><div class=\"ui message\" ng-if=\"data.communityId&&data.communityStatus!=\'active\'&&data.communityStatus!=\'reback\'\"><span ng-if=\"data.communityStatus==\'inactive\'\">您的申请已提交管理员审核，请耐心等待。</span> <span ng-if=\"data.communityStatus==\'modified\'\">您修改的信息已提交管理员审核，请耐心等待。</span></div><div class=\"ui message\" ng-if=\"data.communityStatus==\'reback\'\">您的审核被驳回，原因：<span ng-bind=\"oprlogData.oprComment||\'无\'\"></span></div><div class=\"ui message green\" ng-if=\"data.communityStatus==\'active\'\">恭喜您，审核通过！</div><!--<div class=\"org\">\r\n                    <div class=\"switchBar\" ng-click=\"switch()\">申请记录</div>\r\n                    <table border=\"0\" cellpadding=\"0\" cellspacing=\"1\">\r\n                        <tr>\r\n                            <th width=\"100\">愿状态</th>\r\n                            <th width=\"100\">新状态</th>\r\n                            <th width=\"160\">时间</th>\r\n                            <th>说明</th>\r\n                        </tr>\r\n                        <tr ng-repeat=\"item in oprlogList\">\r\n                            <td ng-bind=\"getStatusTypeName(item.oprOldStatus)\"></td>\r\n                            <td ng-bind=\"getStatusTypeName(item.oprNewStatus)\"></td>\r\n                            <td ng-bind=\"item.oprTime\"></td>\r\n                            <td ng-bind=\"item.oprComment||\'无\'\"></td>\r\n                        </tr>\r\n                    </table>\r\n                </div>--><form class=form name=form novalidate><div class=field><label>用户名称：</label><input class=input type=text placeholder=必填项，请填写单位名称，如XXX街道、XXX学校。 name=communityName ng-model=data.communityName required></div><div class=field><label>管理人姓名：</label><input class=input type=text placeholder=必填项，请填写管理人姓名。 name=communityAdmin ng-model=data.communityAdmin required></div><div class=field><label>E-mail：</label><input class=input type=text placeholder=必填项，请填写E-mail name=communityEmail ng-model=data.communityEmail required></div><div class=field ng-if=!adminUserEv><label>联系电话：</label><input class=input type=text placeholder=必填项，请填写联系电话，以便及时与您取得联系。 name=communityPhone ng-model=data.communityPhone required></div><div class=field ng-if=!adminUserEv><label>地址：</label><input class=input type=text placeholder=必填项，请填写完整地址。 name=communityAddr ng-model=data.communityAddr required></div><div class=field><label>机构描述：</label><textarea ng-model=data.communityDesc name=communityDesc rows=5 placeholder=选填项，请填写单位的简要描述。></textarea></div><button class=\"submit ui button\" ng-class={disabled:form.$invalid} ng-disabled=form.$invalid ng-click=submit()><span ng-if=!data.communityId>提交申请</span> <span ng-if=\"data.communityId&&data.communityStatus==\'active\'\">修改信息</span> <span ng-if=\"data.communityId&&data.communityStatus!=\'active\'\">重新提交</span></button></form></div></div></div></div>");
$templateCache.put("app/module/user/list/list.html","<div id=user-list><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-user.png locations=locations></div><div user-nav=user.list></div><div class=columnContent><div class=content><ul class=list><li ng-repeat=\"item in list\" class=item><div class=preview><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情><img ng-src={{item.documentAvatar|indexImg:0}}></a></div><div class=info><div class=title><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情 ng-bind=item.documentTitle></a></div><div class=other><p>时 间：<span ng-bind=getActivityTime(item.documentStartTime,item.documentEndTime)></span></p><p>主/承办单位：<span ng-bind=item.documentOrganizer></span></p><p>活动类型：<span ng-bind=getActivityTypeName(item.documentType)></span></p><p>总预约人数：<span ng-bind=item.documentTotalNum></span> / 仍可预约<span ng-bind=item.documentRemainNum></span>人</p><p>预约数量：<span ng-bind=item.orderNum></span></p><p>预约时间：<span ng-bind=item.relationTime></span></p></div></div><a ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime) class=cancel ng-click=cancel(item)></a> <a class=print ng-click=\"nativeOpen(\'print\',{id:item.relationId})\"></a></li></ul><div pagination=\"\" page-total=totalPage ng-if=\"list.length>0\"></div><div ng-if=\"list.length==0\" class=nothing>没有符合条件的记录</div></div></div></div></div>");
$templateCache.put("app/module/user/info/info.html","<div id=user-info><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-user.png locations=locations></div><div user-nav=user.info></div><!--<div class=\"ui message\" ng-if=\"!data.idCard\">\r\n            您还没有填写身份证信息，暂无法进行活动预约。\r\n        </div>--><div class=columnContent><img class=userAvatar ng-src={{data.userAvatar|defaultAvatar}}><div class=content><div><label>用户编号：</label><span ng-bind=data.userId></span></div><div><label>真实姓名：</label><span ng-bind=data.trueName></span></div><div><label>手机号码：</label><span ng-bind=data.phone></span></div><div><label>电子邮箱：</label><span ng-bind=data.email></span></div><!--<div>\r\n                    <label>身份证号：</label><span ng-bind=\"data.idCard\"></span>\r\n                </div>--></div></div></div></div>");
$templateCache.put("app/module/user/pwd/pwd.html","<div id=user-pwd><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-user.png locations=locations></div><div user-nav=user.pwd></div><div class=columnContent><div class=content><form class=form name=form novalidate><div class=field ng-class=\"{\'error\':form.oldPwd.$touched && form.oldPwd.$invalid}\"><label>原始密码：</label><input class=input type=password placeholder=必填项，请输入原始密码 name=oldPwd ng-model=data.oldPwd required></div><div class=field ng-class=\"{\'error\':form.password.$touched && form.password.$invalid}\"><label>新的密码：</label><input class=input type=password placeholder=必填项，请输入新的密码 name=password ng-model=data.password required></div><div class=field ng-class=\"{\'error\':form.passwordT.$touched && form.passwordT.$invalid}\"><label>确认密码：</label><input class=input type=password placeholder=必填项，请再次输入新的密码 name=passwordT ng-model=data.passwordT required></div><div class=buttons><button class=\"submit ui button\" onclick=\"return false\" ng-disabled=form.$invalid ng-click=submit() ng-class={disabled:form.$invalid}>确定修改</button> <button class=\"reset ui button gray\" onclick=\"return false\" ng-click=reset()>重填</button></div></form></div></div></div></div>");
$templateCache.put("app/module/user/update/update.html","<div id=user-update><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-user.png locations=locations></div><div user-nav=user.update></div><div class=columnContent><div class=content><!--<div class=\"field\">\r\n                    <label>用户头像：</label>\r\n                    <upload ng-model=\"data.userAvatar\" width=\"200\" height=\"200\">\r\n                        选填项，用于展示用户的头像。\r\n                    </upload>\r\n                </div>--><form class=form name=form novalidate><div class=field><label>用户头像：</label><div user-avatar=\"\" ng-model=data.userAvatar required>请在以下头像中挑选您头像，以便进行展示。</div></div><div class=field><label>真实姓名：</label><input class=input type=text placeholder=选填项，请填写用户真实姓名 name=trueName ng-model=data.trueName></div><div class=field><label><span>*</span>电子邮箱：<span style=\"vertical-align: baseline\">(请再次确认您的电子邮箱真实有效)</span></label><input class=input type=text placeholder=必填项，请填写电子邮箱 name=email ng-model=data.email required></div><div class=field><label><span>*</span>手机号码：<span style=\"vertical-align: baseline\">(请再次确认您的手机号码真实有效)</span></label><input class=input type=number placeholder=必填项，请填写手机号码 name=phone ng-model=data.phone required></div><!--<div class=\"field\" ng-if=\"!adminUserEv\">\r\n                        <label><span>*</span>身份证编号：</label>\r\n                        <input class=\"input\" type=\"text\" placeholder=\"必填项，请填写身份证编号\" name=\"idCard\"\r\n                               ng-readonly=\"otherData.canEditIdCard\"\r\n                               ng-model=\"data.idCard\" required/>\r\n                    </div>--> <button class=\"submit ui button\" onclick=\"return false\" ng-class={disabled:form.$invalid} ng-disabled=form.$invalid ng-click=submit()>确认信息并提交</button></form></div></div></div></div>");
$templateCache.put("app/module/vender/detail/detail.html","<div id=vender-detail><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-vender.png locations=locations></div><div class=columnContent><div class=topBlock><!-- <div class=\"superSlide\" ng-if=\"data.venderAvatar\">\r\n                    <ul class=\"preview\">\r\n                        <li ng-repeat=\"item in data.venderAvatar\">\r\n                            <img ng-src=\"{{item.img}}\"/>\r\n                            <div class=\"bar\" ng-bind=\"item.title\"></div>\r\n                        </li>\r\n                    </ul>\r\n                    <div class=\"footerBar\">\r\n                        <a class=\"prev\" href=\"javascript:;\"></a>\r\n                        <a class=\"next\" href=\"javascript:;\"></a>\r\n                        <div class=\"pageState\"></div>\r\n                    </div>\r\n                </div> --><div class=preview style=\"display: inline\"><img ng-src={{data.venderAvatar[0].img}}></div><div class=description><div class=title ng-bind=data.venderName></div><div class=desc ng-bind=data.venderDesc></div><div class=info><p ng-bind=data.venderLinkman></p><p ng-bind=data.parentId></p><p ng-bind=data.venderEmail></p></div><a class=link ng-href={{data.venderUrl}} ng-if=data.venderUrl></a></div></div><div tabs=\"\"><div tab=\"\" title=常设活动><div ng-if=\"list3.length>0\"><ul class=list><li ng-repeat=\"item in list3\" class=item><div class=preview><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情><img ng-src={{item.documentAvatar|indexImg:0}}></a></div><div class=info><div class=title><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情 ng-bind=item.documentTitle></a></div><div class=other><p>主/承办单位：<span ng-bind=item.documentOrganizer></span></p><p>咨询电话：<span ng-bind=item.documentMobileid></span></p><p>活动地址：<span ng-bind=item.documentAddr></span></p><p>活动类型：<span ng-bind=getActivityTypeName(item.documentType)></span></p></div></div></li></ul><div pagination=\"\" page-total=pageTotal3 page-num=pageNum3 page-change=getData3></div></div><div class=nothing ng-if=\"list3.length==0\">没有符合条件的记录</div></div><div tab=\"\" title=活动预约><div ng-if=\"list2.length>0\"><ul class=list><li ng-repeat=\"item in list2\" class=item><div class=preview><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情><img ng-src={{item.documentAvatar|indexImg:0}}></a></div><div class=info><div class=title><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情 ng-bind=item.documentTitle></a></div><div class=other><p>时 间：<span ng-bind=getActivityTime(item.documentStartTime,item.documentEndTime)></span></p><p>主/承办单位：<span ng-bind=item.documentOrganizer></span></p><p>活动类型：<span ng-bind=getActivityTypeName(item.documentType)></span></p><p>总预约人数： <span ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)><span ng-bind=item.documentTotalNum></span> / 仍可预约<span ng-bind=item.documentRemainNum></span>人 </span><span ng-if=!compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)>已结束</span></p></div></div><a ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime) class=reserve ng-click=reserve(item) ng-class=\"{can:item.documentRemainNum!=0}\"></a></li></ul><div pagination=\"\" page-total=pageTotal2 page-num=pageNum2 page-change=getData2></div></div><div class=nothing ng-if=\"list2.length==0\">没有符合条件的记录</div></div><div tab=\"\" title=往期活动><div ng-if=\"list1.length>0\"><ul class=list><li ng-repeat=\"item in list1\" class=item><div class=preview><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情><img ng-src={{item.documentAvatar|indexImg:0}}></a></div><div class=info><div class=title><a target=_blank ui-sref=activity.detail({id:item.documentId}) title=点击查看详情 ng-bind=item.documentTitle></a></div><div class=other><p>时 间：<span ng-bind=getActivityTime(item.documentStartTime,item.documentEndTime)></span></p><p>主/承办单位：<span ng-bind=item.documentOrganizer></span></p><p>活动类型：<span ng-bind=getActivityTypeName(item.documentType)></span></p><p>总预约人数： <span ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)><span ng-bind=item.documentTotalNum></span> / 仍可预约<span ng-bind=item.documentRemainNum></span>人 </span><span ng-if=!compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime)>已结束</span></p></div></div><a ng-if=compareWithNow(item.documentEntryStartTime,item.documentEntryEndTime) class=reserve ng-click=reserve(item) ng-class=\"{can:item.documentRemainNum!=0}\"></a></li></ul><div pagination=\"\" page-total=pageTotal1 page-num=pageNum1 page-change=getData1></div></div><div class=nothing ng-if=\"list1.length==0\">没有符合条件的记录</div></div><div tab=\"\" title=店铺介绍><div ng-bind-html=safeHtml(data.venderContent)></div></div><div tab=\"\" title=店铺地图 click=bug()><div id=allmap></div></div></div></div></div></div>");
$templateCache.put("app/module/vender/search/search.html","<div id=vender-search><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-vender.png locations=locations></div><div class=columnContent><div ng-if=\"list.length>0\"><ul class=list><li ng-repeat=\"item in list\"><a ui-sref=vender.detail({id:item.venderId})><div class=preview><img ng-src={{getVenderFirstAvatar(item.venderAvatar)}}></div><div class=title ng-bind=item.venderName></div></a></li></ul><div pagination=\"\" page-total=totalPage></div></div><div class=nothing ng-if=\"list.length==0\">没有符合条件的记录</div></div></div></div>");
$templateCache.put("app/module/vender/list/list.html","<div id=vender-list><div class=wrapper><div banner=\"\'assets/images/banner.png\'\"></div><div column-title-bar=assets/images/columnTitleBar-vender.png locations=locations></div><div class=columnContent><ul class=tabs><li class=tab ng-class=\"{active:$stateParams.venderType==1}\"><a ui-sref=vender.list({pageNum:1,venderType:1})>科普场馆</a></li><li class=tab ng-class=\"{active:$stateParams.venderType==2}\"><a ui-sref=vender.list({pageNum:1,venderType:2})>主题公园</a></li><li class=tab ng-class=\"{active:$stateParams.venderType==3}\"><a ui-sref=vender.list({pageNum:1,venderType:3})>青少年科普活动站</a></li><li class=tab ng-class=\"{active:$stateParams.venderType==4}\"><a ui-sref=vender.list({pageNum:1,venderType:4})>机构开放</a></li><li class=tab ng-class=\"{active:$stateParams.venderType==5}\"><a ui-sref=vender.list({pageNum:1,venderType:5})>加盟店铺</a></li></ul><div class=recommend ng-if=\"recommendList.length>0\"><ul><li ng-repeat=\"item in recommendList\"><div class=preview><img ng-src={{getVenderFirstAvatar(item.venderAvatar)}}></div><div class=description><div class=title ng-bind=item.venderName></div><div class=desc ng-bind=item.venderDesc></div><a ui-sref=vender.detail({id:item.venderId})>点击进入详情</a></div></li></ul></div><div ng-if=\"list.length>0\"><ul class=list><li ng-repeat=\"item in list\"><a ui-sref=vender.detail({id:item.venderId})><div class=preview><img ng-src={{getVenderFirstAvatar(item.venderAvatar)}}></div><div class=title ng-bind=item.venderName></div></a></li></ul><div pagination=\"\" page-total=totalPage></div></div><div class=nothing ng-if=\"recommendList.length==0&&list.length==0\">没有符合条件的记录</div></div></div></div>");}]);